'use-memo';

import { Box, type BoxProps } from '@mantine/core';

export interface IconProps extends BoxProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

const defaultColor = '#737373';
const defaultSize = 24;

export const DashboardIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V6.8C10 7.92011 10 8.48016 9.78201 8.90798C9.59027 9.28431 9.28431 9.59027 8.90798 9.78201C8.48016 10 7.92011 10 6.8 10H5.2C4.07989 10 3.51984 10 3.09202 9.78201C2.71569 9.59027 2.40973 9.28431 2.21799 8.90798C2 8.48016 2 7.92011 2 6.8V5.2Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 5.2C14 4.07989 14 3.51984 14.218 3.09202C14.4097 2.71569 14.7157 2.40973 15.092 2.21799C15.5198 2 16.0799 2 17.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.07989 22 5.2V6.8C22 7.92011 22 8.48016 21.782 8.90798C21.5903 9.28431 21.2843 9.59027 20.908 9.78201C20.4802 10 19.9201 10 18.8 10H17.2C16.0799 10 15.5198 10 15.092 9.78201C14.7157 9.59027 14.4097 9.28431 14.218 8.90798C14 8.48016 14 7.92011 14 6.8V5.2Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 17.2C2 16.0799 2 15.5198 2.21799 15.092C2.40973 14.7157 2.71569 14.4097 3.09202 14.218C3.51984 14 4.07989 14 5.2 14H6.8C7.92011 14 8.48016 14 8.90798 14.218C9.28431 14.4097 9.59027 14.7157 9.78201 15.092C10 15.5198 10 16.0799 10 17.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V17.2Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 17.2C14 16.0799 14 15.5198 14.218 15.092C14.4097 14.7157 14.7157 14.4097 15.092 14.218C15.5198 14 16.0799 14 17.2 14H18.8C19.9201 14 20.4802 14 20.908 14.218C21.2843 14.4097 21.5903 14.7157 21.782 15.092C22 15.5198 22 16.0799 22 17.2V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H17.2C16.0799 22 15.5198 22 15.092 21.782C14.7157 21.5903 14.4097 21.2843 14.218 20.908C14 20.4802 14 19.9201 14 18.8V17.2Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const UserIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 18.8C4 16.149 6.14903 14 8.8 14H15.2C17.851 14 20 16.149 20 18.8V18.8C20 20.5673 18.5673 22 16.8 22H7.2C5.43269 22 4 20.5673 4 18.8V18.8Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const UserSquareIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V12.4C22 15.7603 22 17.4405 21.346 18.7239C20.7708 19.8529 19.8529 20.7708 18.7239 21.346C17.4405 22 15.7603 22 12.4 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 13H10.6666C9.1939 13 8 14.1939 8 15.6666C8 16.403 8.59695 17 9.33332 17H14.6667C15.4031 17 16 16.403 16 15.6666C16 14.1939 14.8061 13 13.3334 13Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const UserPlusIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 7V10M20 10V13M20 10H17M20 10H23M13 6C13 8.20914 11.2091 10 9 10C6.79086 10 5 8.20914 5 6C5 3.79086 6.79086 2 9 2C11.2091 2 13 3.79086 13 6ZM5.2 22H12.8C14.5673 22 16 20.5673 16 18.8V18.8C16 16.149 13.851 14 11.2 14H6.8C4.14903 14 2 16.149 2 18.8V18.8C2 20.5673 3.43269 22 5.2 22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const UsersIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 10C17.2091 10 19 8.20914 19 6C19 3.79086 17.2091 2 15 2M17 22H19.8C21.5673 22 23 20.5673 23 18.8V18.8C23 16.149 20.851 14 18.2 14H17M12 6C12 8.20914 10.2091 10 8 10C5.79086 10 4 8.20914 4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6ZM4.2 22H11.8C13.5673 22 15 20.5673 15 18.8V18.8C15 16.149 12.851 14 10.2 14H5.8C3.14903 14 1 16.149 1 18.8V18.8C1 20.5673 2.43269 22 4.2 22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CalculatorIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 2.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 0.8125}
    viewBox="0 0 96 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M26 56C26 57.1046 25.1046 58 24 58C22.8954 58 22 57.1046 22 56M26 56C26 54.8954 25.1046 54 24 54C22.8954 54 22 54.8954 22 56M26 56L22 56M26 72C26 73.1046 25.1046 74 24 74C22.8954 74 22 73.1046 22 72M26 72C26 70.8954 25.1046 70 24 70C22.8954 70 22 70.8954 22 72M26 72L22 72M42 56C42 57.1046 41.1046 58 40 58C38.8954 58 38 57.1046 38 56M42 56C42 54.8954 41.1046 54 40 54C38.8954 54 38 54.8954 38 56M42 56L38 56M42 72C42 73.1046 41.1046 74 40 74C38.8954 74 38 73.1046 38 72M42 72C42 70.8954 41.1046 70 40 70C38.8954 70 38 70.8954 38 72M42 72L38 72M58 56C58 57.1046 57.1046 58 56 58C54.8954 58 54 57.1046 54 56M58 56C58 54.8954 57.1046 54 56 54C54.8954 54 54 54.8954 54 56M58 56L54 56M58 72C58 73.1046 57.1046 74 56 74C54.8954 74 54 73.1046 54 72M58 72C58 70.8954 57.1046 70 56 70C54.8954 70 54 70.8954 54 72M58 72L54 72M26.4 40L53.6 40C55.8402 40 56.9603 40 57.816 39.564C58.5686 39.1805 59.1805 38.5686 59.564 37.816C60 36.9603 60 35.8402 60 33.6L60 26.4C60 24.1598 60 23.0397 59.564 22.184C59.1805 21.4314 58.5686 20.8195 57.816 20.436C56.9603 20 55.8402 20 53.6 20L26.4 20C24.1598 20 23.0397 20 22.184 20.436C21.4314 20.8195 20.8195 21.4314 20.436 22.184C20 23.0397 20 24.1598 20 26.4L20 33.6C20 35.8402 20 36.9603 20.436 37.816C20.8195 38.5686 21.4314 39.1805 22.184 39.564C23.0397 40 24.1598 40 26.4 40Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88 40L72 40M72 28L75.2 28C79.6804 28 81.9206 28 83.6319 28.8719C85.1372 29.6389 86.3611 30.8628 87.1281 32.3681C88 34.0794 88 36.3196 88 40.8L88 55.2C88 59.6804 88 61.9206 87.1281 63.6319C86.3611 65.1372 85.1372 66.3611 83.6319 67.128C81.9206 68 79.6804 68 75.2 68L72 68M24 88L56 88C61.6005 88 64.4008 88 66.5399 86.9101C68.4215 85.9513 69.9513 84.4215 70.9101 82.5399C72 80.4008 72 77.6005 72 72L72 24C72 18.3995 72 15.5992 70.9101 13.4601C69.9513 11.5785 68.4215 10.0487 66.5399 9.08992C64.4008 7.99999 61.6005 7.99999 56 7.99999L24 8C18.3995 8 15.5992 8 13.4601 9.08993C11.5785 10.0487 10.0487 11.5785 9.08994 13.4601C8 15.5992 8 18.3995 8 24L8.00001 72C8.00001 77.6005 8.00001 80.4008 9.08995 82.5399C10.0487 84.4215 11.5785 85.9513 13.4601 86.9101C15.5992 88 18.3995 88 24 88Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const FingerprintIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 10C20 5.58172 16.4183 2 12 2C10.9391 2 9.92643 2.20651 9 2.58152M14.5 21.6016C17.6939 20.5518 20 17.5452 20 14M9.5 21.6016C6.30607 20.5518 4 17.5452 4 14V10C4 8.10811 4.65672 6.3696 5.75463 5M12 10V14M8 14V10C8 7.79086 9.79086 6 12 6M15.4649 8C15.8052 8.58835 16 9.27143 16 10V14C16 16.2091 14.2091 18 12 18C11.2714 18 10.5883 17.8052 10 17.4649"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const NotificationIcon = ({
  size = 16,
  color = defaultColor,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 1.125}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.66668 15.2883C5.21552 16.5232 6.64869 17.3338 8.00004 17.3338C9.35138 17.3338 10.7846 16.5232 11.3334 15.2883M13.0001 8.32558V5.66702C13.0001 2.90558 10.7615 0.666992 8.00004 0.666992V0.666992C5.2386 0.666992 3.00001 2.90558 3.00001 5.66702V8.32558C3.00001 9.02033 2.70513 9.68244 2.18872 10.1472L1.26545 10.9782C0.163355 11.97 0.514969 13.7786 1.90842 14.2853L2.08425 14.3492C5.9057 15.7389 10.0944 15.7389 13.9158 14.3492L14.0917 14.2853C15.4851 13.7786 15.8367 11.97 14.7346 10.9782L13.8114 10.1472C13.295 9.68244 13.0001 9.02033 13.0001 8.32558Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const GeneralIcon = ({
  size = 18,
  color = defaultColor,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3334 4.00035C12.3334 2.15939 10.841 0.666992 9.00008 0.666992C7.15911 0.666992 5.66672 2.15939 5.66672 4.00035M5.66672 7.75037V10.2504M12.3334 7.75037V10.2504M16.5001 9.00038V10.9338C16.5001 13.174 16.5001 14.2941 16.0642 15.1497C15.6807 15.9024 15.0687 16.5143 14.3161 16.8978C13.4604 17.3338 12.3403 17.3338 10.1001 17.3338H7.90003C5.65982 17.3338 4.53971 17.3338 3.68406 16.8978C2.93142 16.5143 2.31949 15.9024 1.936 15.1497C1.50003 14.2941 1.50003 13.174 1.50003 10.9338V9.00038M3.16671 9.00038H14.8334C15.2981 9.00038 15.5305 9.00038 15.7237 8.96195C16.517 8.80413 17.1372 8.18395 17.295 7.39057C17.3335 7.19737 17.3335 6.96504 17.3335 6.50036V6.50036C17.3335 6.03569 17.3335 5.80336 17.295 5.61015C17.1372 4.81678 16.517 4.1966 15.7237 4.03878C15.5305 4.00035 15.2981 4.00035 14.8334 4.00035H3.1667C2.70203 4.00035 2.4697 4.00035 2.27649 4.03878C1.48312 4.1966 0.862935 4.81678 0.705119 5.61015C0.666687 5.80336 0.666687 6.03569 0.666687 6.50036V6.50036C0.666687 6.96504 0.666687 7.19737 0.705119 7.39057C0.862935 8.18395 1.48312 8.80413 2.27649 8.96195C2.4697 9.00038 2.70203 9.00038 3.16671 9.00038Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const FileTextIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2.5V4.80003C14 5.92013 14 6.48019 14.218 6.90801C14.4097 7.28433 14.7157 7.5903 15.092 7.78204C15.5198 8.00003 16.0799 8.00003 17.2 8.00003H19.5M9 12H15M9 16H13M20 10.3137V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const FileCheckIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2.5V4.80003C14 5.92013 14 6.48019 14.218 6.90801C14.4097 7.28433 14.7157 7.5903 15.092 7.78204C15.5198 8.00003 16.0799 8.00003 17.2 8.00003H19.5M9.5 14.5L11 16L15 12M20 10.3137V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const ExternalLinkIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3H9.5V3C8.10547 3 7.40821 3 6.83277 3.13815C5.00453 3.57707 3.57707 5.00453 3.13815 6.83277C3 7.40821 3 8.10547 3 9.5V13C3 15.8003 3 17.2004 3.54497 18.27C4.02433 19.2108 4.78924 19.9757 5.73005 20.455C6.79961 21 8.19974 21 11 21H14.5C15.8945 21 16.5918 21 17.1672 20.8618C18.9955 20.4229 20.4229 18.9955 20.8618 17.1672C21 16.5918 21 15.8945 21 14.5V14.5V14M12 12L21 3M21 3H15M21 3V9"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const Link2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2893 18.7484L11.5786 19.4816C9.61616 21.5061 6.43435 21.5061 4.47186 19.4816C2.50938 17.457 2.50938 14.1745 4.47186 12.1499L6.16656 10.4016C7.97808 8.53279 10.9151 8.53279 12.7267 10.4016L13 10.6836M11.7107 5.25159L12.4214 4.51843C14.3838 2.49386 17.5657 2.49386 19.5281 4.51843C21.4906 6.543 21.4906 9.82549 19.5281 11.8501L17.8334 13.5984C16.0219 15.4672 13.0849 15.4672 11.2733 13.5984L11 13.3164"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const Calculator2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 2,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.375 24.5C11.375 24.9832 10.9833 25.375 10.5 25.375C10.0168 25.375 9.625 24.9832 9.625 24.5M11.375 24.5C11.375 24.0167 10.9833 23.625 10.5 23.625C10.0168 23.625 9.625 24.0167 9.625 24.5M11.375 24.5L9.625 24.5M11.375 31.5C11.375 31.9832 10.9833 32.375 10.5 32.375C10.0168 32.375 9.625 31.9832 9.625 31.5M11.375 31.5C11.375 31.0167 10.9833 30.625 10.5 30.625C10.0168 30.625 9.625 31.0167 9.625 31.5M11.375 31.5L9.625 31.5M18.375 24.5C18.375 24.9832 17.9833 25.375 17.5 25.375C17.0168 25.375 16.625 24.9832 16.625 24.5M18.375 24.5C18.375 24.0167 17.9833 23.625 17.5 23.625C17.0168 23.625 16.625 24.0167 16.625 24.5M18.375 24.5L16.625 24.5M18.375 31.5C18.375 31.9832 17.9833 32.375 17.5 32.375C17.0168 32.375 16.625 31.9832 16.625 31.5M18.375 31.5C18.375 31.0167 17.9833 30.625 17.5 30.625C17.0168 30.625 16.625 31.0167 16.625 31.5M18.375 31.5L16.625 31.5M25.375 24.5C25.375 24.9832 24.9833 25.375 24.5 25.375C24.0168 25.375 23.625 24.9832 23.625 24.5M25.375 24.5C25.375 24.0167 24.9833 23.625 24.5 23.625C24.0168 23.625 23.625 24.0167 23.625 24.5M25.375 24.5L23.625 24.5M25.375 31.5C25.375 31.9832 24.9833 32.375 24.5 32.375C24.0168 32.375 23.625 31.9832 23.625 31.5M25.375 31.5C25.375 31.0167 24.9833 30.625 24.5 30.625C24.0168 30.625 23.625 31.0167 23.625 31.5M25.375 31.5L23.625 31.5M38.5 17.5L31.5 17.5M31.5 12.25L32.9 12.25C34.8602 12.25 35.8403 12.25 36.589 12.6315C37.2475 12.967 37.783 13.5025 38.1185 14.161C38.5 14.9097 38.5 15.8898 38.5 17.85L38.5 24.15C38.5 26.1102 38.5 27.0903 38.1185 27.839C37.783 28.4975 37.2475 29.033 36.589 29.3685C35.8403 29.75 34.8602 29.75 32.9 29.75L31.5 29.75M11.55 17.5L23.45 17.5C24.4301 17.5 24.9201 17.5 25.2945 17.3093C25.6238 17.1415 25.8915 16.8738 26.0593 16.5445C26.25 16.1701 26.25 15.6801 26.25 14.7L26.25 11.55C26.25 10.5699 26.25 10.0799 26.0593 9.70551C25.8915 9.37623 25.6238 9.10851 25.2945 8.94073C24.9201 8.75 24.4301 8.75 23.45 8.75L11.55 8.75C10.5699 8.75 10.0799 8.75 9.70552 8.94074C9.37623 9.10852 9.10852 9.37623 8.94074 9.70552C8.75 10.0799 8.75 10.5699 8.75 11.55L8.75 14.7C8.75 15.6801 8.75 16.1701 8.94074 16.5445C9.10852 16.8738 9.37624 17.1415 9.70552 17.3093C10.0799 17.5 10.5699 17.5 11.55 17.5ZM11.9 38.5L23.1 38.5C26.0403 38.5 27.5104 38.5 28.6335 37.9278C29.6213 37.4244 30.4245 36.6213 30.9278 35.6334C31.5 34.5104 31.5 33.0403 31.5 30.1L31.5 11.9C31.5 8.95972 31.5 7.48958 30.9278 6.36654C30.4244 5.37869 29.6213 4.57555 28.6335 4.07221C27.5104 3.5 26.0403 3.5 23.1 3.5L11.9 3.5C8.95972 3.5 7.48959 3.5 6.36655 4.07222C5.3787 4.57555 4.57555 5.3787 4.07222 6.36655C3.5 7.48959 3.5 8.95973 3.5 11.9L3.5 30.1C3.50001 33.0403 3.50001 34.5104 4.07222 35.6335C4.57556 36.6213 5.3787 37.4244 6.36656 37.9278C7.48959 38.5 8.95973 38.5 11.9 38.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const FileText2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 2.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 0.8125}
    viewBox="0 0 96 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M56 10V19.2001C56 23.6805 56 25.9207 56.8719 27.632C57.6389 29.1373 58.8628 30.3612 60.3681 31.1282C62.0794 32.0001 64.3196 32.0001 68.8 32.0001H78M36 48H60M36 64H52"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 24C16 18.3995 16 15.5992 17.0899 13.4601C18.0487 11.5785 19.5785 10.0487 21.4601 9.08993C23.5992 8 26.3995 8 32 8H53.3726C55.8185 8 57.0414 8 58.1923 8.2763C59.2127 8.52127 60.1881 8.92531 61.0828 9.4736C62.092 10.092 62.9568 10.9568 64.6863 12.6863L75.3137 23.3137C77.0432 25.0432 77.908 25.908 78.5264 26.9172C79.0747 27.8119 79.4787 28.7873 79.7237 29.8077C80 30.9586 80 32.1815 80 34.6274V72C80 77.6005 80 80.4008 78.9101 82.5399C77.9513 84.4215 76.4215 85.9513 74.5399 86.9101C72.4008 88 69.6005 88 64 88H32C26.3995 88 23.5992 88 21.4601 86.9101C19.5785 85.9513 18.0487 84.4215 17.0899 82.5399C16 80.4008 16 77.6005 16 72V24Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const MembersIcon = ({
  size = 20,
  color = defaultColor,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 0.9}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5001 7.3337C14.341 7.3337 15.8334 5.84131 15.8334 4.00035C15.8334 2.15939 14.341 0.666992 12.5001 0.666992M14.1667 17.3338H16.5001C17.9729 17.3338 19.1668 16.1399 19.1668 14.6671V14.6671C19.1668 12.4579 17.3759 10.6671 15.1667 10.6671H14.1667M10 4.00035C10 5.84131 8.50765 7.3337 6.66668 7.3337C4.82572 7.3337 3.33333 5.84131 3.33333 4.00035C3.33333 2.15939 4.82572 0.666992 6.66668 0.666992C8.50765 0.666992 10 2.15939 10 4.00035ZM3.5 17.3338H9.83337C11.3061 17.3338 12.5001 16.1399 12.5001 14.6671V14.6671C12.5001 12.4579 10.7092 10.6671 8.50003 10.6671H4.83334C2.62419 10.6671 0.833313 12.4579 0.833313 14.6671V14.6671C0.833313 16.1399 2.02723 17.3338 3.5 17.3338Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const BillingIcon = ({
  size = 18,
  color = defaultColor,
  strokeWidth = 1.2,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.08336 5.66767H16.9168M4.00004 9.00103H7.3334M7.06669 16.5011H10.9335C13.1737 16.5011 14.2938 16.5011 15.1494 16.0651C15.9021 15.6816 16.514 15.0697 16.8975 14.317C17.3335 13.4614 17.3335 12.3413 17.3335 10.1011V7.90098C17.3335 5.66077 17.3335 4.54066 16.8975 3.68501C16.514 2.93237 15.9021 2.32044 15.1494 1.93695C14.2938 1.50098 13.1737 1.50098 10.9335 1.50098H7.06669C4.82648 1.50098 3.70637 1.50098 2.85072 1.93695C2.09808 2.32044 1.48615 2.93237 1.10266 3.68501C0.666687 4.54066 0.666687 5.66077 0.666687 7.90098V10.1011C0.666687 12.3413 0.666687 13.4614 1.10266 14.317C1.48615 15.0697 2.09808 15.6816 2.85072 16.0651C3.70637 16.5011 4.82648 16.5011 7.06669 16.5011Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const PlansIcon = ({
  size = 18,
  color = defaultColor,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 1.111}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3335 10.8345L13.2933 12.8546C11.7191 13.6417 10.932 14.0352 10.1065 14.1901C9.37524 14.3273 8.62489 14.3273 7.89368 14.1901C7.0681 14.0352 6.281 13.6417 4.70682 12.8546L0.666678 10.8345M17.3335 15.0012L13.2933 17.0213C11.7191 17.8084 10.932 18.2019 10.1065 18.3568C9.37524 18.494 8.62489 18.494 7.89368 18.3568C7.0681 18.2019 6.281 17.8084 4.70682 17.0213L0.666678 15.0012M4.72433 8.69667L6.1379 9.40345C7.18736 9.92818 7.71209 10.1905 8.26248 10.2938C8.74995 10.3853 9.25018 10.3853 9.73766 10.2938C10.288 10.1905 10.8128 9.92818 11.8622 9.40346L13.2758 8.69667C15.1182 7.77546 16.0394 7.31485 16.3351 6.69156C16.5923 6.14915 16.5923 5.51987 16.3351 4.97746C16.0394 4.35416 15.1182 3.89355 13.2758 2.97234L11.8622 2.26556C10.8128 1.74083 10.288 1.47846 9.73766 1.3752C9.25018 1.28374 8.74995 1.28374 8.26248 1.3752C7.71209 1.47846 7.18736 1.74083 6.1379 2.26556L4.72433 2.97234C2.88191 3.89355 1.96069 4.35416 1.66508 4.97746C1.40782 5.51987 1.40782 6.14915 1.66508 6.69156C1.96069 7.31485 2.88191 7.77546 4.72433 8.69667Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const ApiTokensIcon = ({
  size = 18,
  color = defaultColor,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.6668 0.66748L8.58341 7.75086M10.6668 12.3342C10.6668 15.0957 8.42816 17.3343 5.66672 17.3343C2.90528 17.3343 0.666687 15.0957 0.666687 12.3342C0.666687 9.57278 2.90528 7.33419 5.66672 7.33419C8.42816 7.33419 10.6668 9.57278 10.6668 12.3342ZM17.3335 4.00084L14.4168 6.91752L10.2501 6.08418L14.8334 1.50082L17.3335 4.00084Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const WebhookIcon = ({
  color = defaultColor,
  size = 20,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 0.9}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.50008 17.3343H6.52367C5.41266 17.3343 4.85716 17.3343 4.43209 17.1197C4.05042 16.9271 3.74053 16.6172 3.54788 16.2355C3.33331 15.8104 3.33331 15.2549 3.33331 14.1439V14.1439C3.33331 13.1734 3.33331 12.6882 3.22455 12.2313C3.12616 11.8181 2.96256 11.4231 2.7399 11.0613C2.49377 10.6614 2.15065 10.3183 1.4644 9.63202L0.833252 9.00088L1.4644 8.36975C2.15065 7.68351 2.49378 7.34039 2.7399 6.94045C2.96256 6.57865 3.12616 6.1837 3.22455 5.77043C3.33331 5.31359 3.33331 4.82834 3.33331 3.85784V3.85784C3.33331 2.74682 3.33331 2.19131 3.54788 1.76623C3.74054 1.38457 4.05043 1.07468 4.43209 0.882032C4.85717 0.667467 5.41268 0.667471 6.5237 0.667478C6.86491 0.667481 7.19288 0.667485 7.50008 0.667492M12.5001 0.667489C12.8066 0.667483 13.1347 0.667479 13.4765 0.667477C14.5875 0.667472 15.143 0.667469 15.5681 0.882031C15.9498 1.07468 16.2596 1.38457 16.4523 1.76624C16.6669 2.19131 16.6669 2.74682 16.6669 3.85785V3.85785C16.6669 4.82834 16.6669 5.31359 16.7756 5.77042C16.874 6.18369 17.0376 6.57865 17.2603 6.94045C17.5064 7.34039 17.8495 7.6835 18.5358 8.36974L19.1669 9.00088L18.5358 9.63202C17.8495 10.3183 17.5064 10.6614 17.2603 11.0613C17.0376 11.4231 16.874 11.8181 16.7756 12.2313C16.6669 12.6882 16.6669 13.1734 16.6669 14.1439V14.1439C16.6669 15.2549 16.6669 15.8104 16.4523 16.2355C16.2596 16.6172 15.9498 16.9271 15.5681 17.1197C15.143 17.3343 14.5875 17.3343 13.4765 17.3343H12.5001M10.4168 4.83418C10.4168 5.0643 10.2302 5.25084 10.0001 5.25084C9.76996 5.25084 9.58341 5.0643 9.58341 4.83418M10.4168 4.83418C10.4168 4.60405 10.2302 4.41751 10.0001 4.41751C9.76996 4.41751 9.58341 4.60405 9.58341 4.83418M10.4168 4.83418H9.58341M10.4168 9.00087C10.4168 9.23099 10.2302 9.41754 10.0001 9.41754C9.76996 9.41754 9.58341 9.23099 9.58341 9.00087M10.4168 9.00087C10.4168 8.77075 10.2302 8.5842 10.0001 8.5842C9.76996 8.5842 9.58341 8.77075 9.58341 9.00087M10.4168 9.00087H9.58341M10.4168 13.1676C10.4168 13.3977 10.2302 13.5842 10.0001 13.5842C9.76996 13.5842 9.58341 13.3977 9.58341 13.1676M10.4168 13.1676C10.4168 12.9374 10.2302 12.7509 10.0001 12.7509C9.76996 12.7509 9.58341 12.9374 9.58341 13.1676M10.4168 13.1676H9.58341"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const OwnerPortalIcon = ({
  size = 18,
  color = defaultColor,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.50006 0.66748L6.50006 17.3343M7.06669 17.3343H10.9335C13.1737 17.3343 14.2938 17.3343 15.1494 16.8983C15.9021 16.5148 16.514 15.9029 16.8975 15.1502C17.3335 14.2946 17.3335 13.1745 17.3335 10.9343V7.06748C17.3335 4.82727 17.3335 3.70717 16.8975 2.85152C16.514 2.09887 15.9021 1.48695 15.1494 1.10345C14.2938 0.66748 13.1737 0.66748 10.9335 0.66748H7.06669C4.82648 0.66748 3.70637 0.66748 2.85072 1.10345C2.09808 1.48695 1.48615 2.09887 1.10266 2.85152C0.666687 3.70717 0.666687 4.82727 0.666687 7.06748V10.9343C0.666687 13.1745 0.666687 14.2946 1.10266 15.1502C1.48615 15.9029 2.09808 16.5148 2.85072 16.8983C3.70637 17.3343 4.82648 17.3343 7.06669 17.3343Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);
export const OwnerStatementsIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.2,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size * 1.125}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.66676 1.08415V2.46754C9.66676 3.58764 9.66676 4.1477 9.88475 4.57552C10.0765 4.95184 10.3825 5.2578 10.7588 5.44955C11.1866 5.66754 11.7467 5.66754 12.8668 5.66754H14.2501M5.50007 9.00087H10.5001M5.50007 12.3342H8.83342M14.6668 7.48514V10.9343C14.6668 13.1745 14.6668 14.2946 14.2308 15.1502C13.8473 15.9029 13.2354 16.5148 12.4828 16.8983C11.6271 17.3343 10.507 17.3343 8.2668 17.3343H7.73337C5.49316 17.3343 4.37306 17.3343 3.51741 16.8983C2.76476 16.5148 2.15284 15.9029 1.76935 15.1502C1.33337 14.2946 1.33337 13.1745 1.33337 10.9343V7.06748C1.33337 4.82727 1.33337 3.70717 1.76935 2.85152C2.15284 2.09887 2.76476 1.48695 3.51741 1.10345C4.37306 0.66748 5.49316 0.66748 7.73337 0.66748H7.84913C8.8275 0.66748 9.31668 0.66748 9.77703 0.778001C10.1852 0.875988 10.5754 1.0376 10.9332 1.25692C11.3369 1.50429 11.6828 1.85019 12.3746 2.542L12.7923 2.95966C13.4841 3.65147 13.83 3.99737 14.0774 4.40104C14.2967 4.75892 14.4583 5.1491 14.5563 5.55725C14.6668 6.0176 14.6668 6.50678 14.6668 7.48514Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CircleDollarIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 14C9 15.1046 9.89543 16 11 16H13.2566C14.2194 16 15 15.2194 15 14.2566C15 13.5062 14.5198 12.8399 13.8079 12.6026L10.1921 11.3974C9.48019 11.1601 9 10.4938 9 9.74342C9 8.78055 9.78055 8 10.7434 8H13C14.1046 8 15 8.89543 15 10M12 6.5V17.5M22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22V22C17.5228 22 22 17.5228 22 12Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const BankAccountIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.4882 2.55413C10.7999 2.69573 11 3.00647 11 3.34881C11 3.83087 10.6092 4.22165 10.1272 4.22165H1.37284C0.890782 4.22165 0.5 3.83087 0.5 3.34881C0.5 3.00647 0.700135 2.69573 1.01183 2.55413L5.33639 0.589544C5.59921 0.470152 5.90079 0.470152 6.16361 0.589544L10.4882 2.55413Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      d="M10.045 8.99165H1.455C0.927568 8.99165 0.5 9.41922 0.5 9.94665C0.5 10.4741 0.927568 10.9016 1.455 10.9016H10.045C10.5724 10.9016 11 10.4741 11 9.94665C11 9.41922 10.5724 8.99165 10.045 8.99165Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      d="M1.455 4.22165V8.99165"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      d="M4.32 4.22165V8.99165"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      d="M7.18 4.22165V8.99165"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
    <path
      d="M10.045 4.22165V8.99165"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeMiterlimit="10"
    />
  </Box>
);

export const HomeIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 22V15C15 14.0681 15 13.6022 14.8478 13.2346C14.6448 12.7446 14.2554 12.3552 13.7654 12.1522C13.3978 12 12.9319 12 12 12V12C11.0681 12 10.6022 12 10.2346 12.1522C9.74458 12.3552 9.35523 12.7446 9.15224 13.2346C9 13.6022 9 14.0681 9 15V22M7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const BedIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 12V9.4C20 7.15979 20 6.03968 19.564 5.18404C19.1805 4.43139 18.5686 3.81947 17.816 3.43597C16.9603 3 15.8402 3 13.6 3H10.4C8.15979 3 7.03968 3 6.18404 3.43597C5.43139 3.81947 4.81947 4.43139 4.43597 5.18404C4 6.03968 4 7.15979 4 9.4V12M2 15V21M22 15V21M16 12V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V12M22 19V15.2C22 14.0799 22 13.5198 21.782 13.092C21.5903 12.7157 21.2843 12.4097 20.908 12.218C20.4802 12 19.9201 12 18.8 12H5.2C4.07989 12 3.51984 12 3.09202 12.218C2.71569 12.4097 2.40973 12.7157 2.21799 13.092C2 13.5198 2 14.0799 2 15.2V19H22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const PlusIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 12H12M19 12H12M12 12V5M12 12V19"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const PlusCircleIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12H12M12 12H16M12 12V8M12 12V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const MinusCircleIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const UserCrossIcon = ({
  size = 16,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 12L20.5 9.5M20.5 9.5L23 7M20.5 9.5L18 7M20.5 9.5L23 12M13 6C13 8.20914 11.2091 10 9 10C6.79086 10 5 8.20914 5 6C5 3.79086 6.79086 2 9 2C11.2091 2 13 3.79086 13 6ZM5.2 22H12.8C14.5673 22 16 20.5673 16 18.8V18.8C16 16.149 13.851 14 11.2 14H6.8C4.14903 14 2 16.149 2 18.8V18.8C2 20.5673 3.43269 22 5.2 22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const PercentageCircleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9999 7L8.99988 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.99988 9.5C9.99988 10.3284 9.32831 11 8.49988 11C7.67145 11 6.99988 10.3284 6.99988 9.5C6.99988 8.67157 7.67145 8 8.49988 8C9.32831 8 9.99988 8.67157 9.99988 9.5ZM16.9999 14.5C16.9999 15.3284 16.3283 16 15.4999 16C14.6715 16 13.9999 15.3284 13.9999 14.5C13.9999 13.6716 14.6715 13 15.4999 13C16.3283 13 16.9999 13.6716 16.9999 14.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const PercentageIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.0001 3L6.00012 21M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const AutomationsIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.2,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.58368 8.75098L1.66699 6.66755L2.16168 6.17288C3.04719 5.28739 3.48995 4.84465 4.01389 4.56482C4.47773 4.31709 4.98586 4.16324 5.50922 4.11209C6.10038 4.05431 6.71436 4.17711 7.94232 4.42272L8.74997 4.58426M15.4166 11.251L15.5783 12.0585C15.8241 13.2866 15.947 13.9007 15.8893 14.492C15.8381 15.0154 15.6843 15.5236 15.4366 15.9876C15.1567 16.5116 14.7139 16.9544 13.8282 17.8401L13.3339 18.3343L11.2506 15.4177M5.83328 14.1676L7.49983 12.501M14.1687 7.50057C14.1687 8.42105 13.4225 9.16724 12.502 9.16724C11.5815 9.16724 10.8353 8.42105 10.8353 7.50057C10.8353 6.58009 11.5815 5.83389 12.502 5.83389C13.4225 5.83389 14.1687 6.58009 14.1687 7.50057ZM14.038 1.6676V1.6676C13.3347 1.6676 12.9831 1.6676 12.6482 1.72491C12.059 1.82574 11.4999 2.05735 11.0119 2.40271C10.7346 2.59901 10.486 2.84766 9.98873 3.34494L5.83302 7.50097C5.36403 7.97 5.12953 8.20452 4.96064 8.42893C3.88864 9.85335 3.88868 11.8153 4.96074 13.2396C5.12964 13.464 5.36414 13.6985 5.83315 14.1676V14.1676C6.30219 14.6366 6.53671 14.8711 6.76114 15.04C8.1856 16.1121 10.1476 16.1121 11.572 15.0399C11.7965 14.871 12.031 14.6365 12.5 14.1674L16.6556 10.0115C17.1528 9.51424 17.4014 9.26559 17.5977 8.98823C17.943 8.50037 18.1745 7.94136 18.2753 7.35226C18.3327 7.01734 18.3327 6.66569 18.3326 5.9624V5.9624C18.3326 4.75697 18.3326 4.15425 18.162 3.67011C17.86 2.81374 17.1865 2.1402 16.3301 1.83829C15.846 1.6676 15.2433 1.6676 14.038 1.6676Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const ChevronIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6.5L8 10.5L12 6.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const SearchIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 21L17.364 17.364M17.364 17.364C18.9926 15.7353 20 13.4853 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.4853 20 15.7353 18.9926 17.364 17.364Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const ArchiveIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 6V15.6C20 17.8402 20 18.9603 19.564 19.816C19.1805 20.5686 18.5686 21.1805 17.816 21.564C16.9603 22 15.8402 22 13.6 22H10.4C8.15979 22 7.03969 22 6.18404 21.564C5.43139 21.1805 4.81947 20.5686 4.43597 19.816C4 18.9603 4 17.8402 4 15.6V6M9 10H15M4 6H20C21.1046 6 22 5.10457 22 4V4C22 2.89543 21.1046 2 20 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CheckIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 13L9 18L20 6"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CrossIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 18L18 6M6 6L18 18"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CrossCircleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 15L12 12M12 12L15 9M12 12L9 9M12 12L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const FileDownloadIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2.5V4.80003C14 5.92013 14 6.48019 14.218 6.90801C14.4097 7.28433 14.7157 7.5903 15.092 7.78204C15.5198 8.00003 16.0799 8.00003 17.2 8.00003H19.5M12 11V17M12 17L14.5 14.5M12 17L9.5 14.5M20 10.3137V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const RefreshCwIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 3 16.5 3 16.5M2 12C2 6.47715 6.44444 2 12 2C18.6667 2 22 7.5 22 7.5M22 7.5V4M22 7.5H18.5M3 16.5H6.5M3 16.5V20"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CopyIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1668 8V8C17.8742 8 18.7279 8 19.4091 8.25638C20.4872 8.66213 21.338 9.51294 21.7437 10.591C22.0001 11.2722 22.0001 12.1259 22.0001 13.8333V15.6C22.0001 17.8402 22.0001 18.9603 21.5641 19.816C21.1807 20.5686 20.5687 21.1805 19.8161 21.564C18.9604 22 17.8403 22 15.6001 22H13.8335C12.126 22 11.2723 22 10.5911 21.7436C9.51306 21.3379 8.66225 20.4871 8.2565 19.409C8.00012 18.7278 8.00012 17.8741 8.00012 16.1667V16.1667M8.40012 16H9.60012C11.8403 16 12.9604 16 13.8161 15.564C14.5687 15.1805 15.1807 14.5686 15.5641 13.816C16.0001 12.9603 16.0001 11.8402 16.0001 9.6V8.4C16.0001 6.15979 16.0001 5.03968 15.5641 4.18404C15.1807 3.43139 14.5687 2.81947 13.8161 2.43597C12.9604 2 11.8403 2 9.60012 2H8.40012C6.15991 2 5.03981 2 4.18416 2.43597C3.43151 2.81947 2.81959 3.43139 2.4361 4.18404C2.00012 5.03968 2.00012 6.15979 2.00012 8.4V9.6C2.00012 11.8402 2.00012 12.9603 2.4361 13.816C2.81959 14.5686 3.43151 15.1805 4.18416 15.564C5.03981 16 6.15991 16 8.40012 16Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const TrashIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 5L4.64564 15.9758C4.77037 18.0962 4.83273 19.1564 5.28528 19.961C5.68366 20.6692 6.28832 21.2394 7.01876 21.5955C7.84851 22 8.91054 22 11.0346 22H12.9654C15.0895 22 16.1515 22 16.9812 21.5955C17.7117 21.2394 18.3163 20.6692 18.7147 19.961C19.1673 19.1564 19.2296 18.0962 19.3544 15.9758L20 5M4 5H2M4 5H20M20 5H22M16 5L15.547 3.64105C15.3503 3.05094 15.252 2.75588 15.0695 2.53774C14.9084 2.3451 14.7016 2.19599 14.4679 2.10408C14.2032 2 13.8922 2 13.2702 2H10.7298C10.1078 2 9.79677 2 9.53213 2.10408C9.29844 2.19599 9.09156 2.3451 8.93047 2.53774C8.74804 2.75588 8.64969 3.05094 8.45298 3.64105L8 5M10 10V17M14 10V14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const EyeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 12C22 14.5 19 20 12 20C5 20 2 14.5 2 12C2 9.5 5 4 12 4C19 4 22 9.5 22 12Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </Box>
);

export const EyeSlashIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 3L5.82578 5.82578M21 21L18.1742 18.1742M18.1742 18.1742C16.6292 19.2482 14.588 20 12 20C5 20 2 14.5 2 12C2 10.4243 3.19179 7.65676 5.82578 5.82578M18.1742 18.1742L14.1213 14.1213M5.82578 5.82578L9.87863 9.87863M9.87863 9.87863C9.33571 10.4215 8.99991 11.1715 8.99991 12C8.99991 13.6569 10.3431 15 11.9999 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87863 9.87863L14.1213 14.1213M20.4197 16C20.5431 15.8341 20.659 15.6671 20.7674 15.5C21.6051 14.2091 22 12.9071 22 12C22 9.5 19 4 12 4C10.903 4 9.90427 4.13507 8.99991 4.3725C8.82995 4.41712 8.66332 4.46536 8.5 4.517"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const AiSparkIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 14.5L5.7 16.3L7.5 17L5.7 17.7L5 19.5L4.3 17.7L2.5 17L4.3 16.3L5 14.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 3.5L19.5 4.7L20.7 5.2L19.5 5.7L19 7L18.5 5.7L17.3 5.2L18.5 4.7L19 3.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const AiSparkOffIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4L20 20"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3L13.7 8.3L19 10L15.7 11.1M12 17L10.3 11.7L5 10L8.3 8.9"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 14.5L5.7 16.3L7.5 17L5.7 17.7L5 19.5L4.3 17.7L2.5 17L4.3 16.3L5 14.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const RocketIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.50049 10.5L2.00049 7.9999L3.07849 6.92193C3.964 6.03644 4.40676 5.5937 4.9307 5.31387C5.39454 5.06614 5.90267 4.91229 6.42603 4.86114C7.01719 4.80336 7.63117 4.92617 8.85913 5.17177L10.5 5.49997M18.4999 13.5L18.8284 15.1408C19.0742 16.3689 19.1971 16.983 19.1394 17.5743C19.0883 18.0977 18.9344 18.6059 18.6867 19.0699C18.4068 19.5939 17.964 20.0367 17.0783 20.9224L16.0007 22L13.5007 18.5M7 16.9998L8.99985 15M17.0024 8.99951C17.0024 10.1041 16.107 10.9995 15.0024 10.9995C13.8979 10.9995 13.0024 10.1041 13.0024 8.99951C13.0024 7.89494 13.8979 6.99951 15.0024 6.99951C16.107 6.99951 17.0024 7.89494 17.0024 8.99951ZM17.1991 2H16.6503C15.6718 2 15.1826 2 14.7223 2.11053C14.3141 2.20853 13.9239 2.37016 13.566 2.5895C13.1623 2.83689 12.8164 3.18282 12.1246 3.87469L6.99969 9C5.90927 10.0905 5.36406 10.6358 5.07261 11.2239C4.5181 12.343 4.51812 13.6569 5.07268 14.776C5.36415 15.3642 5.90938 15.9094 6.99984 16.9998V16.9998C8.09038 18.0904 8.63565 18.6357 9.22386 18.9271C10.343 19.4817 11.6569 19.4817 12.7761 18.9271C13.3643 18.6356 13.9095 18.0903 15 16.9997L20.1248 11.8745C20.8165 11.1827 21.1624 10.8368 21.4098 10.4331C21.6291 10.0753 21.7907 9.6851 21.8886 9.27697C21.9991 8.81664 21.9991 8.32749 21.9991 7.34918V6.8C21.9991 5.11984 21.9991 4.27976 21.6722 3.63803C21.3845 3.07354 20.9256 2.6146 20.3611 2.32698C19.7194 2 18.8793 2 17.1991 2Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const EmailIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 8L17 8.66667L16.4376 9.0416C14.8338 10.1108 14.0319 10.6454 13.1652 10.8531C12.3992 11.0366 11.6008 11.0366 10.8348 10.8531C9.96808 10.6454 9.16618 10.1108 7.5624 9.0416L7 8.66667L6 8M10 21H14C16.8003 21 18.2004 21 19.27 20.455C20.2108 19.9757 20.9757 19.2108 21.455 18.27C22 17.2004 22 15.8003 22 13V11C22 8.19974 22 6.79961 21.455 5.73005C20.9757 4.78924 20.2108 4.02433 19.27 3.54497C18.2004 3 16.8003 3 14 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V13C2 15.8003 2 17.2004 2.54497 18.27C3.02433 19.2108 3.78924 19.9757 4.73005 20.455C5.79961 21 7.19974 21 10 21Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const ContactAtIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 5.5C8 6.88071 6.88071 8 5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5ZM8 5.5V3.5M8 5.5L8.00001 6.47238C8 7 8.25 7.75 9 7.75C10 7.75 10.5 6.60063 10.5 5.5C10.5 2.73858 8.26142 0.5 5.5 0.5C2.73858 0.5 0.5 2.73858 0.5 5.5C0.5 8.26142 2.73858 10.5 5.5 10.5C6.29825 10.5 7.0528 10.3129 7.72222 9.98027"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const CommentQuestionIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16M12.5 16C12.5 15.7239 12.2761 15.5 12 15.5C11.7239 15.5 11.5 15.7239 11.5 16M12.5 16H11.5M10 10.5V10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10V10.1213C14 10.6839 13.7765 11.2235 13.3787 11.6213L12 13M22 12C22 17.5228 17.5228 22 12 22C10.8606 22 9.88354 21.8377 8.97627 21.5132C8.11879 21.2065 7.69003 21.0531 7.52552 21.0144C6.0076 20.6574 5.3779 21.6977 4.06965 21.9157C3.42708 22.0228 2.85534 21.4967 2.90866 20.8475C2.95529 20.2798 3.34789 19.7429 3.50454 19.1977C3.83022 18.0644 3.38829 17.2052 2.9214 16.1973C2.33015 14.921 2 13.499 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const GearIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4.00004C11.303 4.00004 10.6132 3.73831 10.1864 3.18734L9.73424 2.60372C9.12172 1.81308 8.01933 1.59645 7.15318 2.09652L5.84684 2.85074C4.98069 3.35081 4.6171 4.41383 4.99556 5.3396L5.27481 6.02271C5.5387 6.66822 5.42168 7.39321 5.0722 7.99668V7.99668C4.72303 8.59962 4.15039 9.07044 3.46003 9.16458L2.72977 9.26416C1.7388 9.39929 1 10.2457 1 11.2458V12.7543C1 13.7544 1.7388 14.6008 2.72977 14.7359L3.46006 14.8355C4.1504 14.9296 4.72303 15.4004 5.07219 16.0034V16.0034C5.42166 16.6068 5.53867 17.3318 5.27479 17.9773L4.99554 18.6604C4.61708 19.5862 4.98067 20.6492 5.84682 21.1493L7.15316 21.9035C8.01931 22.4035 9.1217 22.1869 9.73422 21.3963L10.1863 20.8128C10.6131 20.2618 11.303 20 12 20V20V20C12.6971 20 13.387 20.2618 13.8139 20.8129L14.2658 21.3961C14.8783 22.1867 15.9807 22.4034 16.8468 21.9033L18.1532 21.1491C19.0193 20.649 19.3829 19.586 19.0045 18.6602L18.7252 17.9772C18.4614 17.3317 18.5784 16.6068 18.9278 16.0033V16.0033C19.277 15.4004 19.8496 14.9296 20.5399 14.8355L21.2702 14.7359C22.2612 14.6008 23 13.7544 23 12.7543V11.2458C23 10.2457 22.2612 9.39929 21.2702 9.26416L20.5399 9.16458C19.8496 9.07044 19.277 8.59963 18.9278 7.99671V7.99671C18.5784 7.39326 18.4613 6.6683 18.7252 6.02281L19.0044 5.33977C19.3829 4.414 19.0193 3.35099 18.1532 2.85092L16.8468 2.0967C15.9807 1.59663 14.8783 1.81326 14.2658 2.6039L13.8138 3.18725C13.3869 3.73829 12.697 4.00004 12 4.00004V4.00004V4.00004Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Menu2RecIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 8H17M7 12H13M7 16H15M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const MenuIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 6H21M3 12H21M3 18H21"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Maximize3Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 8V7.5V7.5C22 6.10444 22 5.40666 21.8278 4.83886C21.44 3.56046 20.4395 2.56004 19.1611 2.17224C18.5933 2 17.8956 2 16.5 2V2H16M22 16V16.5V16.5C22 17.8956 22 18.5933 21.8278 19.1611C21.44 20.4395 20.4395 21.44 19.1611 21.8278C18.5933 22 17.8956 22 16.5 22V22H16M2 16V16.5V16.5C2 17.8956 2 18.5933 2.17224 19.1611C2.56004 20.4395 3.56046 21.44 4.83886 21.8278C5.40666 22 6.10444 22 7.5 22V22H8M2 8V7.5V7.5C2 6.10444 2 5.40666 2.17224 4.83886C2.56004 3.56046 3.56046 2.56004 4.83886 2.17224C5.40666 2 6.10444 2 7.5 2V2H8"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const MinimizeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 2V4.8C8 5.92011 8 6.48016 7.78201 6.90798C7.59027 7.28431 7.28431 7.59027 6.90798 7.78201C6.48016 8 5.9201 8 4.8 8H2M8 22V19.2C8 18.0799 8 17.5198 7.78201 17.092C7.59027 16.7157 7.28431 16.4097 6.90798 16.218C6.48016 16 5.9201 16 4.8 16H2M16 2V4.8C16 5.92011 16 6.48016 16.218 6.90798C16.4097 7.28431 16.7157 7.59027 17.092 7.78201C17.5198 8 18.0799 8 19.2 8H22M16 22V19.2C16 18.0799 16 17.5198 16.218 17.092C16.4097 16.7157 16.7157 16.4097 17.092 16.218C17.5198 16 18.0799 16 19.2 16H22"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowRightIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 11.9999H21M21 11.9999L14 5M21 11.9999L14 18.9999"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const WrenchIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 16C18.866 16 22 12.866 22 9C22 8.30503 21.8987 7.63371 21.7101 7L19.2627 9.44738L19.2627 9.4474C18.4707 10.2394 18.0747 10.6354 17.618 10.7838C17.2163 10.9143 16.7837 10.9143 16.382 10.7838C15.9253 10.6354 15.5293 10.2394 14.7373 9.44738L14.5526 9.26274C13.7606 8.47071 13.3646 8.07469 13.2162 7.61803C13.0857 7.21635 13.0857 6.78365 13.2162 6.38197C13.3646 5.92531 13.7606 5.52929 14.5526 4.73726L17 2.28988C16.3663 2.10128 15.695 2 15 2C11.134 2 8 5.13401 8 9C8 10.0736 8.06806 11.5907 8.5 12.5L2.5 18.5L2.49986 18.5001C2.4203 18.5797 2.3805 18.6195 2.34847 18.6547C1.65508 19.4176 1.65508 20.5824 2.34847 21.3453C2.3805 21.3805 2.4203 21.4203 2.49987 21.4999L2.5 21.5C2.57965 21.5797 2.61948 21.6195 2.65474 21.6515C3.41756 22.3449 4.58244 22.3449 5.34526 21.6515C5.38052 21.6195 5.42035 21.5797 5.5 21.5L11.5 15.5C12.4093 15.9319 13.9264 16 15 16Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowTopIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 21L12 3M12 3L19 10M12 3L5 10"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowBottomIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3L12 21M12 21L19 14M12 21L5 14"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowCornerCcwRbIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 16L16 21M21 16L16 11M21 16C18.1926 16 13.3531 16 9.39883 16C7.1594 16 6.03968 16 5.18404 15.564C4.43139 15.1805 3.81947 14.5686 3.43597 13.816C3 12.9603 3 11.8402 3 9.6V3"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ImportIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 14V14.5V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V14.5L2 14M12 2V14M12 14L16 10M12 14L8 10"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ExportIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 14V14.5V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V14.5V14M12 14V2M12 2L16 6M12 2L8 6"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const SlidersHorizIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 18.9998H22M19 18.9998C19 20.6566 17.6569 21.9998 16 21.9998C14.3431 21.9998 13 20.6566 13 18.9998C13 17.3429 14.3431 15.9998 16 15.9998C17.6569 15.9998 19 17.3429 19 18.9998ZM2 11.9998H5M5 11.9998C5 13.6566 6.34315 14.9998 8 14.9998C9.65685 14.9998 11 13.6566 11 11.9998C11 10.3429 9.65685 8.99979 8 8.99979C6.34315 8.99979 5 10.3429 5 11.9998ZM19 4.99979H22M19 4.99979C19 6.65664 17.6569 7.99979 16 7.99979C14.3431 7.99979 13 6.65664 13 4.99979C13 3.34293 14.3431 1.99979 16 1.99979C17.6569 1.99979 19 3.34293 19 4.99979ZM2 18.9998H10M14 11.9998H22M2 4.99979H10"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ListUnorderedIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00024 20.0002H22.0002M9.00024 12.0002L22.0002 12.0002M9.00024 4.0002H22.0002M3.50024 4.0002C3.50024 4.27634 3.27639 4.5002 3.00024 4.5002C2.7241 4.5002 2.50024 4.27634 2.50024 4.0002M3.50024 4.0002C3.50024 3.72406 3.27639 3.5002 3.00024 3.5002C2.7241 3.5002 2.50024 3.72406 2.50024 4.0002M3.50024 4.0002H2.50024M3.50024 12.0002C3.50024 12.2763 3.27639 12.5002 3.00024 12.5002C2.7241 12.5002 2.50024 12.2763 2.50024 12.0002M3.50024 12.0002C3.50024 11.7241 3.27639 11.5002 3.00024 11.5002C2.7241 11.5002 2.50024 11.7241 2.50024 12.0002M3.50024 12.0002H2.50024M3.50024 20.0002C3.50024 20.2763 3.27639 20.5002 3.00024 20.5002C2.7241 20.5002 2.50024 20.2763 2.50024 20.0002M3.50024 20.0002C3.50024 19.7241 3.27639 19.5002 3.00024 19.5002C2.7241 19.5002 2.50024 19.7241 2.50024 20.0002M3.50024 20.0002H2.50024"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ShareIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 5.00018C16 6.65704 17.3431 8.00018 19 8.00018C20.6569 8.00018 22 6.65704 22 5.00018C22 3.34333 20.6569 2.00018 19 2.00018C17.3431 2.00018 16 3.34333 16 5.00018ZM16 5.00018H9C6.79086 5.00018 5 6.79104 5 9.00018V9.00018M5 15.0002C3.34315 15.0002 2 13.657 2 12.0002C2 10.3433 3.34315 9.00018 5 9.00018M5 15.0002C6.65685 15.0002 8 13.657 8 12.0002C8 10.3433 6.65685 9.00018 5 9.00018M5 15.0002V15.0002C5 17.2093 6.79086 19.0002 9 19.0002H16M16 19.0002C16 20.657 17.3431 22.0002 19 22.0002C20.6569 22.0002 22 20.657 22 19.0002C22 17.3433 20.6569 16.0002 19 16.0002C17.3431 16.0002 16 17.3433 16 19.0002Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const MoreHorizontalIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 6.33301C2.08334 6.33301 1.33334 7.08301 1.33334 7.99967C1.33334 8.91634 2.08334 9.66634 3 9.66634C3.91667 9.66634 4.66667 8.91634 4.66667 7.99967C4.66667 7.08301 3.91667 6.33301 3 6.33301Z"
        fill={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M13 6.33301C12.0833 6.33301 11.3333 7.08301 11.3333 7.99967C11.3333 8.91634 12.0833 9.66634 13 9.66634C13.9167 9.66634 14.6667 8.91634 14.6667 7.99967C14.6667 7.08301 13.9167 6.33301 13 6.33301Z"
        fill={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M6.33334 7.99967C6.33334 7.08301 7.08334 6.33301 8 6.33301C8.91667 6.33301 9.66667 7.08301 9.66667 7.99967C9.66667 8.91634 8.91667 9.66634 8 9.66634C7.08334 9.66634 6.33334 8.91634 6.33334 7.99967Z"
        fill={color}
        strokeWidth={strokeWidth}
      />
    </Box>
  );
};

export const GripVerticalIcon = ({
  size = defaultSize,
  color = defaultColor,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="5" cy="4" r="1.25" fill={color} />
      <circle cx="11" cy="4" r="1.25" fill={color} />
      <circle cx="5" cy="8" r="1.25" fill={color} />
      <circle cx="11" cy="8" r="1.25" fill={color} />
      <circle cx="5" cy="12" r="1.25" fill={color} />
      <circle cx="11" cy="12" r="1.25" fill={color} />
    </Box>
  );
};

export const PinIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 10.5C3 5.5 7 2 12 2C17 2 21 5.5 21 10.5C21 18.3518 14 21.9998 12 21.9998C10 21.9998 3 18.3518 3 10.5Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PhoneIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.79292 13C3.44179 10.7109 2.54788 8.04699 2.18421 5.08119C2.07767 4.21233 2.02441 3.77791 2.18022 3.33555C2.34048 2.88055 2.74541 2.42294 3.17752 2.20849C3.59762 2 4.09459 2 5.08854 2V2C5.89832 2 6.30321 2 6.6445 2.12877C7.02426 2.27206 7.35144 2.52752 7.58256 2.86119C7.79026 3.16105 7.88846 3.55385 8.08486 4.33946L8.20715 4.82862C8.49761 5.99044 8.64284 6.57135 8.62096 7.14144C8.60158 7.64628 8.48674 8.14289 8.28251 8.60499C8.05189 9.1268 7.66637 9.58498 6.89534 10.5013L4.79292 13ZM4.79292 13C6.24802 15.4652 8.23342 17.4956 10.6579 19M10.6579 19C13.0221 20.467 15.8039 21.4338 18.9186 21.8158C19.7876 21.9223 20.2221 21.9756 20.6644 21.8198C21.1194 21.6595 21.5771 21.2546 21.7915 20.8225C22 20.4024 22 19.8953 22 18.8811V18.8811C22 18.0916 22 17.6968 21.8712 17.3555C21.7279 16.9757 21.4725 16.6486 21.1388 16.4174C20.8389 16.2097 20.4461 16.1115 19.6605 15.9151L18.9522 15.7381C17.8677 15.4669 17.3254 15.3313 16.7897 15.3428C16.3151 15.3529 15.8462 15.4474 15.4047 15.6219C14.9064 15.8188 14.459 16.1539 13.5641 16.8239L10.6579 19Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Edit3Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 5C15 7.20914 16.7909 9 19 9M4 20L4.61997 16.9002C4.76122 16.1939 4.83185 15.8407 4.96101 15.5114C5.07566 15.2192 5.22432 14.9414 5.40392 14.6839C5.60627 14.3937 5.86092 14.1391 6.37023 13.6298L16.0001 3.99998C16.5454 3.45476 16.818 3.18215 17.1121 3.03641C17.6716 2.75911 18.3286 2.75912 18.8882 3.03643C19.1823 3.18217 19.4549 3.45479 20.0001 4.00003V4.00003C20.5453 4.54525 20.8179 4.81786 20.9636 5.11194C21.2409 5.67151 21.2409 6.32848 20.9636 6.88804C20.8179 7.18212 20.5453 7.45472 20.0001 7.99994L10.3702 17.6298C9.86091 18.1391 9.60626 18.3937 9.31613 18.5961C9.05861 18.7757 8.78084 18.9243 8.48856 19.039C8.15927 19.1681 7.80613 19.2388 7.09987 19.38L4 20Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FunctionsIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 3H5L14.0152 12L5 21H19"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ZeroIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.82556 8.00011C4.82556 9.12265 5.16001 10.1992 5.75532 10.993C6.35064 11.7867 7.15806 12.2327 7.99996 12.2327C8.84187 12.2327 9.64929 11.7867 10.2446 10.993C10.8399 10.1992 11.1744 9.12265 11.1744 8.00011C11.1744 6.87758 10.8399 5.80101 10.2446 5.00726C9.64929 4.2135 8.84187 3.76758 7.99996 3.76758C7.15806 3.76758 6.35064 4.2135 5.75532 5.00726C5.16001 5.80101 4.82556 6.87758 4.82556 8.00011Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1163 4.82617L5.88379 11.175"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const AlignMiddleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2V9M12 9L9 6M12 9L15 6M12 22V15M12 15L9 18M12 15L15 18M3 12H21"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const HistoryIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 12C2 16.9706 6 22 12 22C18 22 22 18 22 12C22 6 18 2 12 2C6 2 2 7 2 7M2 7V3M2 7H5.5M12 8V12L15 14"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ClipboardTextIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3M9 11H15M9 15H13"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ClipboardSlashIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3ZM16 3C18.2091 3 20 4.79086 20 7V14C20 14.5516 20 15.0489 19.9958 15.5M2 2L4.71586 4.71586M22 22L19.3912 19.3912M4.71586 4.71586C4.26461 5.36347 4 6.15083 4 7V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.17 20.9964 18.9091 20.2765 19.3912 19.3912M4.71586 4.71586L19.3912 19.3912"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ShuffleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 20H4.25227C5.59228 20 6.26228 20 6.81969 19.7658C7.31151 19.5592 7.73933 19.2251 8.05907 18.7981C8.42146 18.3142 8.58396 17.6642 8.90896 16.3642L11.091 7.63583C11.416 6.33583 11.5785 5.68584 11.9409 5.20187C12.2607 4.77485 12.6885 4.44082 13.1803 4.23419C13.7377 4 14.4077 4 15.7477 4H22M22 4L19 1M22 4L19 7M2 4H8M22 20L19 23M22 20L19 17M22 20H12"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CalendarEventIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 1V4M16 1V4M17 8H7M17 17H15M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CalendarCrossIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 1V4M16 1V4M9 15L12 12M12 12L15 9M12 12L9 9M12 12L15 15M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const RouteIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 19H16.5C18.433 19 20 17.433 20 15.5V15.5C20 13.567 18.433 12 16.5 12H6.5C4.567 12 3 10.433 3 8.5V8.5C3 6.567 4.567 5 6.5 5H12M8 19C8 20.6569 6.65685 22 5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19ZM12 5L9.5 2.5M12 5L9.5 7.5M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Loader2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.4035 2.37412 8.8944 3.03947 7.55556"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const LoaderIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 6.99989L19.3642 4.63574M4.63623 19.3637L7.00019 16.9997M7.00038 6.99989L4.63623 4.63574M19.3642 19.3637L17.0002 16.9997M18.6566 12H22M2 12H5.34315M12 5.34341V2M12 22V18.6569"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const BookOpenIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 18C14.4268 16.4399 16.2646 16.0156 18.7998 15.9002C19.9707 15.8469 20.5562 15.8203 20.9643 15.5957C21.3343 15.3921 21.6076 15.106 21.7942 14.7271C22 14.3093 22 13.7586 22 12.6571V2C17.5556 2 15.3333 2 12 4.14286M12 18C9.57324 16.4399 7.7354 16.0156 5.20023 15.9002C4.02927 15.8469 3.44379 15.8203 3.03575 15.5957C2.66572 15.3921 2.39236 15.106 2.20576 14.7271C2 14.3093 2 13.7586 2 12.6571V2C6.44444 2 8.66667 2 12 4.14286M12 18V4.14286M21 19.5C17 19.5 15 20 12 22C9 20 7 19.5 3 19.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FolderOpenIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9998 21.9995H6.79976C5.1196 21.9995 4.27952 21.9995 3.63778 21.6725C3.0733 21.3849 2.61436 20.926 2.32674 20.3615C1.99976 19.7197 1.99976 18.8797 1.99976 17.1995V6.79951C1.99976 5.11935 1.99976 4.27928 2.32674 3.63754C2.61436 3.07305 3.0733 2.61411 3.63778 2.32649C4.27952 1.99951 5.1196 1.99951 6.79976 1.99951H7.76369C8.1325 1.99951 8.3169 1.99951 8.48704 2.019C9.37473 2.12067 10.1709 2.61274 10.6588 3.36124C10.7524 3.5047 10.8348 3.66964 10.9998 3.99951V3.99951C11.1647 4.32939 11.2472 4.49432 11.3407 4.63778C11.8286 5.38629 12.6248 5.87835 13.5125 5.98002C13.6826 5.99951 13.867 5.99951 14.2358 5.99951H15.9995C16.9297 5.99951 17.3948 5.99951 17.7764 6.10178C18.8115 6.37922 19.6201 7.18774 19.8975 8.22287C19.9998 8.60446 19.9998 9.06956 19.9998 9.99976V9.99976M5.99976 22L7.33128 14.0109C7.56877 12.5859 7.68751 11.8735 8.04306 11.3388C8.35647 10.8675 8.79681 10.4945 9.31322 10.2628C9.89905 10 10.6214 10 12.066 10H19.2223C20.5219 10 21.1717 10 21.634 10.2651C22.0396 10.4978 22.3509 10.8653 22.5137 11.3036C22.6992 11.8032 22.5924 12.4441 22.3787 13.7261L21.6682 17.9891C21.4307 19.4141 21.312 20.1265 20.9565 20.6612C20.643 21.1325 20.2027 21.5055 19.6863 21.7372C19.1005 22 18.3782 22 16.9335 22H5.99976Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const LightningIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.11942 10.1007L9.72591 4.34261C11.0368 2.70406 11.6922 1.88479 12.2669 1.79439C12.7645 1.71614 13.268 1.89278 13.6076 2.26468C14 2.69433 14 3.74351 14 5.84187V7.6C14 8.44008 14 8.86012 14.1635 9.18099C14.3073 9.46323 14.5368 9.6927 14.819 9.83651C15.1399 10 15.5599 10 16.4 10H17.0065C18.6051 10 19.4043 10 19.8148 10.3277C20.1719 10.6127 20.3796 11.0448 20.3791 11.5016C20.3785 12.0269 19.8792 12.651 18.8806 13.8993L14.2741 19.6574C12.9632 21.2959 12.3078 22.1152 11.7331 22.2056C11.2355 22.2839 10.732 22.1072 10.3924 21.7353C10 21.3057 10 20.2565 10 18.1581V16.4C10 15.5599 10 15.1399 9.83651 14.819C9.6927 14.5368 9.46323 14.3073 9.18099 14.1635C8.86012 14 8.44008 14 7.6 14H6.9935C5.39495 14 4.59567 14 4.18516 13.6723C3.82814 13.3873 3.62044 12.9552 3.62094 12.4984C3.62151 11.9731 4.12081 11.349 5.11942 10.1007Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FileInvoiceIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 2.5V4.80003C14 5.92013 14 6.48019 14.218 6.90801C14.4097 7.28433 14.7157 7.5903 15.092 7.78204C15.5198 8.00003 16.0799 8.00003 17.2 8.00003H19.5M14 11H11.5C10.6716 11 10 11.6716 10 12.5C10 13.3284 10.6716 14 11.5 14H12.5C13.3284 14 14 14.6716 14 15.5C14 16.3284 13.3284 17 12.5 17H10M12 11V10M12 17V18M20 10.3137V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V9.77817C4 7.18697 4 5.89136 4.46859 4.88663C4.96536 3.82147 5.82147 2.96536 6.88663 2.46859C7.89136 2 9.18697 2 11.7782 2V2C12.9105 2 13.4766 2 14.0113 2.11855C14.5806 2.24479 15.1235 2.46965 15.6153 2.78296C16.0772 3.07721 16.4775 3.47753 17.2782 4.27817L17.6569 4.65685C18.5216 5.52161 18.954 5.95399 19.2632 6.45858C19.5373 6.90594 19.7394 7.39366 19.8618 7.90384C20 8.47928 20 9.09076 20 10.3137Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const OfficeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 28.8569H29.5M5.5 28.8569V6.85693C5.5 5.75236 6.39543 4.85693 7.5 4.85693H17.5C18.6046 4.85693 19.5 5.75236 19.5 6.85693V10.8569M19.5 28.8569V10.8569M27.5 28.8569V12.8569C27.5 11.7524 26.6046 10.8569 25.5 10.8569H19.5M9.5 9.85693H10.5M9.5 13.8569H10.5M9.5 17.8569H10.5M14.5 9.85693H15.5M14.5 13.8569H15.5M14.5 17.8569H15.5M9.5 28.8569V24.3569C9.5 23.5289 10.172 22.8569 11 22.8569H14C14.828 22.8569 15.5 23.5289 15.5 24.3569V28.8569M23.5 15.8569H23.5107V15.8676H23.5V15.8569ZM23.5 19.8569H23.5107V19.8676H23.5V19.8569ZM23.5 23.8569H23.5107V23.8676H23.5V23.8569Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const AlertTriangleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 13V9M12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5M12.5 16.5C12.5 16.2239 12.2761 16 12 16C11.7239 16 11.5 16.2239 11.5 16.5M12.5 16.5H11.5M19.3311 10.0912L18.98 9.46437C16.6988 5.39063 15.5581 3.35377 14.0576 2.67625C12.7495 2.08558 11.2505 2.08558 9.94239 2.67625C8.44189 3.35377 7.30124 5.39064 5.01995 9.46438L4.66894 10.0912C2.47606 14.007 1.37961 15.965 1.56302 17.5683C1.72303 18.967 2.46536 20.2335 3.60763 21.0566C4.91688 22 7.16092 22 11.649 22H12.351C16.8391 22 19.0831 22 20.3924 21.0566C21.5346 20.2335 22.277 18.967 22.437 17.5683C22.6204 15.965 21.5239 14.007 19.3311 10.0912Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const AlertTriangleFilledIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.76538 0.759766C6.55016 0.405423 7.44932 0.405515 8.23413 0.759766C9.13443 1.16628 9.81946 2.38877 11.1882 4.83301L11.9119 6.125C13.2276 8.47447 13.8852 9.64937 13.7751 10.6113C13.6791 11.4505 13.2338 12.2103 12.5486 12.7041C11.763 13.2701 10.4162 13.2705 7.72339 13.2705H6.27612C3.58363 13.2705 2.23748 13.27 1.4519 12.7041C0.766554 12.2103 0.320382 11.4506 0.224365 10.6113C0.114324 9.64936 0.772891 8.47452 2.08862 6.125L2.81226 4.83301C4.18103 2.38876 4.86508 1.16628 5.76538 0.759766ZM7.00073 8.83203C6.59103 8.83203 6.25346 9.14405 6.21265 9.54297L6.20874 9.62402L6.21265 9.70508C6.25323 10.1042 6.59087 10.416 7.00073 10.416C7.43759 10.4156 7.79175 10.061 7.79175 9.62402C7.79152 9.21464 7.48041 8.87786 7.08179 8.83691L7.00073 8.83203ZM7.00073 4.74902C6.72474 4.74902 6.50098 4.97309 6.50073 5.24902V7.58203C6.50073 7.85817 6.72459 8.08203 7.00073 8.08203C7.2765 8.08159 7.50073 7.8579 7.50073 7.58203V5.24902C7.50049 4.97336 7.27635 4.74946 7.00073 4.74902Z"
        fill={color}
      />
    </Box>
  );
};

export const HashtagIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3L8 21M16 3L14 21M3 9H21M2 15H20"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowLeftIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 5L3 11.9999M3 11.9999L10 18.9999M3 11.9999H21"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowSwapIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 2L2 6M2 6L6 10M2 6H16M18 14L22 18M22 18L18 22M22 18H8"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowUpDownIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: 'rotate(90deg)',
      }}
      {...props}
    >
      <Box
        component="path"
        d="M6 2L2 6M2 6L6 10M2 6H16M18 14L22 18M22 18L18 22M22 18H8"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CalendarDatesIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 1V4M16 1V4M17.5 8H6.5M8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5M8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5M8 12.5H7M8 16.5C8 16.7761 7.77614 17 7.5 17C7.22386 17 7 16.7761 7 16.5M8 16.5C8 16.2239 7.77614 16 7.5 16C7.22386 16 7 16.2239 7 16.5M8 16.5H7M12.5 12.5C12.5 12.7761 12.2761 13 12 13C11.7239 13 11.5 12.7761 11.5 12.5M12.5 12.5C12.5 12.2239 12.2761 12 12 12C11.7239 12 11.5 12.2239 11.5 12.5M12.5 12.5H11.5M12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5M12.5 16.5C12.5 16.2239 12.2761 16 12 16C11.7239 16 11.5 16.2239 11.5 16.5M12.5 16.5H11.5M17 12.5C17 12.7761 16.7761 13 16.5 13C16.2239 13 16 12.7761 16 12.5M17 12.5C17 12.2239 16.7761 12 16.5 12C16.2239 12 16 12.2239 16 12.5M17 12.5H16M17 16.5C17 16.7761 16.7761 17 16.5 17C16.2239 17 16 16.7761 16 16.5M17 16.5C17 16.2239 16.7761 16 16.5 16C16.2239 16 16 16.2239 16 16.5M17 16.5H16M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const AlertCircleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 13V7M12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5M12.5 16.5C12.5 16.2239 12.2761 16 12 16C11.7239 16 11.5 16.2239 11.5 16.5M12.5 16.5H11.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const LogIn2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8L8 7.50003V7.50003C8 6.10444 8 5.40665 8.17225 4.83884C8.56005 3.56045 9.56045 2.56005 10.8388 2.17225C11.4066 2 12.1044 2 13.5 2L15.6 2C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03969 22 6.15979 22 8.4L22 15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H13.5C12.1044 22 11.4067 22 10.8389 21.8278C9.56046 21.44 8.56003 20.4395 8.17223 19.1611C8 18.5933 8 17.8956 8 16.5V16.5L8 16M2 12H17M17 12L13 8M17 12L13 16"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const LogOutIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 2H9.5H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H9.5H10M10 12H22M22 12L18 8M22 12L18 16"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const LogOut2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 16.0005L13.9999 16.5V16.5C14 17.896 14 18.594 13.8276 19.1619C13.4398 20.4401 12.4396 21.4403 11.1614 21.8281C10.5935 22.0005 9.89549 22.0005 8.49951 22.0005H7.99997C6.13623 22.0005 5.20436 22.0005 4.46929 21.696C3.48916 21.29 2.71045 20.5113 2.30447 19.5312C2 18.7961 2 17.8643 2 16.0005L2 8.00049C2 6.13672 2 5.20484 2.30448 4.46975C2.71046 3.48964 3.48916 2.71095 4.46927 2.30497C5.20435 2.00049 6.13624 2.00049 8 2.00049L8.50049 2.00049C9.8956 2.00049 10.5931 2.00049 11.1608 2.17262C12.4395 2.56037 13.4401 3.56101 13.8279 4.83972C14 5.40734 14 6.10489 14 7.5V7.5L14 8.00049M9 12L22 12M22 12L18 8M22 12L18 16"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CheckCircleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 12.5L11 15L16.5 9.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CreditCardOutcomeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 13.2857V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H8.4C6.15979 3 5.03968 3 4.18404 3.43597C3.43139 3.81947 2.81947 4.43139 2.43597 5.18404C2 6.03968 2 7.15979 2 9.4V14.6C2 16.8402 2 17.9603 2.43597 18.816C2.81947 19.5686 3.43139 20.1805 4.18404 20.564C5.03968 21 6.15979 21 8.4 21H14M2.5 8H21.5M6 12H9M17 19H23M23 19L21 17M23 19L21 21"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CreditCardIncomeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 15.2857V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H15.6C17.8402 3 18.9603 3 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C22 6.03968 22 7.15979 22 9.4V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H11M2 19H8M8 19L6 17M8 19L6 21M2.5 8H21.5M15 12H18"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const InfoIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16V11M12.5 8C12.5 8.27614 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.27614 11.5 8M12.5 8C12.5 7.72386 12.2761 7.5 12 7.5C11.7239 7.5 11.5 7.72386 11.5 8M12.5 8H11.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Send2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2546_6194)">
        <path
          d="M11 13L12.5345 16.9899C13.5893 19.7326 14.1168 21.1039 14.825 21.4489C15.4375 21.7472 16.1598 21.7132 16.7415 21.3586C17.4142 20.9486 17.8104 19.5338 18.6027 16.7041L21.466 6.47824C21.9677 4.68672 22.2185 3.79096 21.9857 3.17628C21.7827 2.64035 21.3596 2.21724 20.8237 2.01427C20.209 1.78147 19.3133 2.03228 17.5217 2.53391L7.29584 5.39716C4.46617 6.18947 3.05133 6.58563 2.64136 7.25828C2.28678 7.84005 2.25275 8.56231 2.55106 9.17484C2.89597 9.88306 4.26729 10.4105 7.00993 11.4654L11 13ZM11 13L13.5 10.5"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        {/** biome-ignore lint/correctness/useUniqueElementIds: svg id */}
        <clipPath id="clip0_2546_6194">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Box>
  );
};

export const BriefcaseIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 11C2.5 11 4.83015 12.0356 8 12.6164M8 12.6164C9.23522 12.8427 10.598 13 12 13C13.402 13 14.7648 12.8427 16 12.6164M8 12.6164V11M8 12.6164V14M16 12.6164C19.1699 12.0356 21.5 11 21.5 11M16 12.6164V11M16 12.6164V14M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6M8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H8.4C6.15979 6 5.03968 6 4.18404 6.43597C3.43139 6.81947 2.81947 7.43139 2.43597 8.18404C2 9.03968 2 10.1598 2 12.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Grid06Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 2L15 22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Activity2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 12H6L9 19L15 5L18 12H22"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ArrowRightCircleIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 11H15M15 11L12 8M15 11L12 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Lock2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 8V6.8C7 5.11984 7 4.27976 7.32698 3.63803C7.6146 3.07354 8.07354 2.6146 8.63803 2.32698C9.27976 2 10.1198 2 11.8 2H12.2C13.8802 2 14.7202 2 15.362 2.32698C15.9265 2.6146 16.3854 3.07354 16.673 3.63803C17 4.27976 17 5.11984 17 6.8V8M12 14V16M9.4 22H14.6C16.8402 22 17.9603 22 18.816 21.564C19.5686 21.1805 20.1805 20.5686 20.564 19.816C21 18.9603 21 17.8402 21 15.6V14.4C21 12.1598 21 11.0397 20.564 10.184C20.1805 9.43139 19.5686 8.81947 18.816 8.43597C17.9603 8 16.8402 8 14.6 8H9.4C7.15979 8 6.03968 8 5.18404 8.43597C4.43139 8.81947 3.81947 9.43139 3.43597 10.184C3 11.0397 3 12.1598 3 14.4V15.6C3 17.8402 3 18.9603 3.43597 19.816C3.81947 20.5686 4.43139 21.1805 5.18404 21.564C6.03968 22 7.15979 22 9.4 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ToggleOnIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 12C1 7.02944 5.02944 3 10 3H14C18.9706 3 23 7.02944 23 12V12C23 16.9706 18.9706 21 14 21H10C5.02944 21 1 16.9706 1 12V12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 12C18 14.2091 16.2091 16 14 16C11.7909 16 10 14.2091 10 12C10 9.79086 11.7909 8 14 8C16.2091 8 18 9.79086 18 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Tag2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 10.349C3 11.3274 3 11.8166 3.11052 12.2769C3.20851 12.6851 3.37012 13.0753 3.58944 13.4331C3.83681 13.8368 4.18271 14.1827 4.87451 14.8745L8.47452 18.4745C10.0586 20.0586 10.8506 20.8506 11.7639 21.1474C12.5673 21.4084 13.4327 21.4084 14.2361 21.1474C15.1494 20.8506 15.9414 20.0586 17.5255 18.4745L18.4745 17.5255C20.0586 15.9414 20.8506 15.1494 21.1474 14.2361C21.4084 13.4327 21.4084 12.5673 21.1474 11.7639C20.8506 10.8506 20.0586 10.0586 18.4745 8.47452L14.8745 4.87452C14.1827 4.18271 13.8368 3.83681 13.4331 3.58944C13.0753 3.37012 12.6851 3.20851 12.2769 3.11052C11.8166 3 11.3274 3 10.349 3H9.4C7.15979 3 6.03968 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3 6.03968 3 7.15979 3 9.4V10.349Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CloudUploadIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M12 22V13M12 13L8.5 16.5M12 13L15.5 16.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CloudDownloadIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M12 13V22M12 22L15.5 18.5M12 22L8.5 18.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Globe2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 19C17.5228 19 22 14.5228 22 9C22 6.27455 20.9097 3.80375 19.1414 2M12 19C9.27455 19 6.80375 17.9097 5 16.1414M12 19V22M12 22H10M12 22H14M19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const GlobeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 9.79086 17.5228 8 12 8C6.47715 8 2 9.79086 2 12M22 12C22 14.2091 17.5228 16 12 16C6.47715 16 2 14.2091 2 12M12 22C6.47715 22 2 17.5228 2 12M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2M12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2M2 12C2 6.47715 6.47715 2 12 2"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const TimeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 8V12L15 14M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const BracketsIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00002 22H7.19993C6.07983 22 5.51978 22 5.09195 21.782C4.71563 21.5903 4.40967 21.2843 4.21792 20.908C3.99993 20.4802 3.99993 19.9201 3.99993 18.8V17.651C3.99993 16.6726 3.99993 16.1835 3.88941 15.7231C3.79142 15.3149 3.6298 14.9248 3.41048 14.5669C3.16311 14.1632 2.8172 13.8173 2.12538 13.1255L0.999878 12L2.12538 10.8745C2.8172 10.1827 3.16311 9.83682 3.41048 9.43315C3.6298 9.07526 3.79142 8.68508 3.88941 8.27693C3.99993 7.81657 3.99993 7.32739 3.99993 6.34901V5.19999C3.99993 4.07988 3.99993 3.51983 4.21792 3.09201C4.40967 2.71569 4.71563 2.40972 5.09195 2.21798C5.51978 1.99999 6.07984 1.99999 7.19997 1.99999C7.83583 2 8.44606 2 9.00002 2.00001M15 2.00001C15.5524 2 16.1632 1.99999 16.8 1.99999C17.9202 1.99999 18.4802 2 18.9081 2.21798C19.2844 2.40973 19.5903 2.71569 19.7821 3.09201C20.0001 3.51984 20.0001 4.07989 20.0001 5.20001V6.34901C20.0001 7.32738 20.0001 7.81657 20.1106 8.27693C20.2086 8.68508 20.3702 9.07526 20.5895 9.43315C20.8369 9.83682 21.1828 10.1827 21.8746 10.8745L23.0001 12L21.8746 13.1255C21.1828 13.8173 20.8369 14.1632 20.5895 14.5669C20.3702 14.9248 20.2086 15.3149 20.1106 15.7231C20.0001 16.1835 20.0001 16.6726 20.0001 17.651V18.8C20.0001 19.9201 20.0001 20.4802 19.7821 20.908C19.5903 21.2843 19.2844 21.5903 18.9081 21.782C18.4802 22 17.9202 22 16.8001 22H15M12.5 7C12.5 7.27614 12.2761 7.5 12 7.5C11.7239 7.5 11.5 7.27614 11.5 7M12.5 7C12.5 6.72386 12.2761 6.5 12 6.5C11.7239 6.5 11.5 6.72386 11.5 7M12.5 7H11.5M12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12M12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12M12.5 12H11.5M12.5 17C12.5 17.2761 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.2761 11.5 17M12.5 17C12.5 16.7239 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.7239 11.5 17M12.5 17H11.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const WifiSlashIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.14648 12.7177C6.51401 11.4302 8.24419 10.5236 10.1675 10.1675M14 10.2C15.8562 10.5768 17.5256 11.4678 18.8533 12.7177M8.1084 15.4329C9.15606 14.5394 10.5149 14 11.9998 14C12.9247 14 13.8007 14.2093 14.5831 14.5831M22.3201 10.5398C19.7609 7.74938 16.0847 6 11.9999 6C11.3209 6 10.6532 6.04834 10 6.14176M1.67969 10.5398C3.12143 8.96783 4.91764 7.72624 6.94168 6.94168M3 3L21 21M12.5 18C12.5 18.2761 12.2761 18.5 12 18.5C11.7239 18.5 11.5 18.2761 11.5 18M12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18M12.5 18H11.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ClockIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 8V12L15 14M4 1L1 4M20 1L23 4M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FilterIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.3652 2H4.6348C3.73193 2 3 2.73193 3 3.6348C3 5.74665 4.01989 7.72849 5.73837 8.95598L7.66667 10.3333L7.66668 10.3333C8.30877 10.792 8.62982 11.0213 8.88894 11.2919C9.42476 11.8514 9.78657 12.5545 9.93043 13.3157C10 13.6838 10 14.0784 10 14.8674V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V14.8674C14 14.0784 14 13.6838 14.0696 13.3157C14.2134 12.5545 14.5752 11.8514 15.1111 11.2919C15.3702 11.0213 15.6912 10.792 16.3333 10.3333L18.2616 8.95598C19.9801 7.72849 21 5.74665 21 3.6348C21 2.73193 20.2681 2 19.3652 2Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const WalletPlusIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H12M22 11H21.5C19.8431 11 18.5 12.3431 18.5 14V14C18.5 15.6569 19.8431 17 21.5 17H22M10 11.5V14M10 14V16.5M10 14H7.5M10 14H12.5M17 6L15.92 4.56C15.216 3.62134 14.864 3.15201 14.4179 2.8135C14.0228 2.5137 13.5754 2.28999 13.0985 2.15378C12.56 2 11.9733 2 10.8 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6H17Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const WalletMinusIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H12M22 11H21.5C19.8431 11 18.5 12.3431 18.5 14V14C18.5 15.6569 19.8431 17 21.5 17H22M7.5 14H10H12.5M17 6L15.92 4.56C15.216 3.62134 14.864 3.15201 14.4179 2.8135C14.0228 2.5137 13.5754 2.28999 13.0985 2.15378C12.56 2 11.9733 2 10.8 2H4C2.89543 2 2 2.89543 2 4V4C2 5.10457 2.89543 6 4 6H17Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FastForwardIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 8.14286L6.93042 6.16956C5.3245 5.13718 4.52153 4.62099 3.85752 4.66841C3.27885 4.70974 2.74665 5.0003 2.39897 5.46471C2 5.99762 2 6.95219 2 8.86133V15.1387C2 17.0478 2 18.0024 2.39897 18.5353C2.74665 18.9997 3.27885 19.2903 3.85752 19.3316C4.52153 19.379 5.3245 18.8628 6.93042 17.8304L10 15.8571M19.8128 14.6918L14.9304 17.8304C13.3245 18.8628 12.5215 19.379 11.8575 19.3316C11.2789 19.2903 10.7466 18.9997 10.399 18.5353C10 18.0024 10 17.0478 10 15.1387V8.86133C10 6.95219 10 5.99762 10.399 5.46471C10.7466 5.0003 11.2789 4.70974 11.8575 4.66841C12.5215 4.62099 13.3245 5.13718 14.9304 6.16956L19.8128 9.30823C21.2063 10.2041 21.9031 10.652 22.1438 11.2216C22.3541 11.7192 22.3541 12.2808 22.1438 12.7784C21.9031 13.348 21.2063 13.7959 19.8128 14.6918Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PauseIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 6.2C3 5.07989 3 4.51984 3.21799 4.09202C3.40973 3.71569 3.71569 3.40973 4.09202 3.21799C4.51984 3 5.07989 3 6.2 3H6.8C7.9201 3 8.48016 3 8.90798 3.21799C9.28431 3.40973 9.59027 3.71569 9.78201 4.09202C10 4.51984 10 5.0799 10 6.2V17.8C10 18.9201 10 19.4802 9.78201 19.908C9.59027 20.2843 9.28431 20.5903 8.90798 20.782C8.48016 21 7.92011 21 6.8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V6.2Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 6.2C14 5.07989 14 4.51984 14.218 4.09202C14.4097 3.71569 14.7157 3.40973 15.092 3.21799C15.5198 3 16.0799 3 17.2 3H17.8C18.9201 3 19.4802 3 19.908 3.21799C20.2843 3.40973 20.5903 3.71569 20.782 4.09202C21 4.51984 21 5.0799 21 6.2V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H17.2C16.0799 21 15.5198 21 15.092 20.782C14.7157 20.5903 14.4097 20.2843 14.218 19.908C14 19.4802 14 18.9201 14 17.8V6.2Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FormulaIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9608_44552)">
        <path
          d="M2 13.1667C2 13.5203 2.14048 13.8594 2.39052 14.1095C2.64057 14.3595 2.97971 14.5 3.33333 14.5C4.66667 14.5 4.66667 11.8333 5.33333 8.5C6 5.16667 6 2.5 7.33333 2.5C7.68695 2.5 8.02609 2.64048 8.27614 2.89052C8.52619 3.14057 8.66667 3.47971 8.66667 3.83333"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33398 8.5H7.33398"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 8.5L14 12.5"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 12.5L14 8.5"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        {/** biome-ignore lint/correctness/useUniqueElementIds: svg id */}
        <clipPath id="clip0_9608_44552">
          <rect
            width={size}
            height={size}
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </Box>
  );
};

export const ClockZzzIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 1L1 4M20 1L23 4M10 9H14L10 15H14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const StripeIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.63533 4.37067C4.63533 3.95533 4.98067 3.718 5.59667 3.718C6.72333 3.718 7.87 3.94667 8.66667 4.33333L9 1.66667C8.368 1.36733 7.12 1 5.33333 1C4.07 1 3.08467 1.058 2.33333 1.66667C1.552 2.304 1 3.22 1 4.33333C1 6.35333 2.30533 7.604 4.33333 8.33333C5.64067 8.79333 6.33333 8.82867 6.33333 9.33333C6.33333 9.82333 5.766 10.3333 5 10.3333C4.05133 10.3333 2.358 9.92733 1.33333 9.33333L1 12C1.88067 12.4893 3.316 13 5 13C6.33333 13 7.638 12.688 8.38933 12.0933C9.23133 11.4407 9.66667 10.5813 9.66667 9.33333C9.66667 7.26933 8.39 6.302 6.33333 5.57533C5.236 5.172 4.63733 4.862 4.63733 4.37067H4.63533Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const BookingComIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.7,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33317 5.99996H5.6665C6.02013 5.99996 6.35926 6.14044 6.60931 6.39048C6.85936 6.64053 6.99984 6.97967 6.99984 7.33329C6.99984 7.68691 6.85936 8.02605 6.60931 8.2761C6.35926 8.52615 6.02013 8.66663 5.6665 8.66663H3.33317V3.99996C3.33317 3.82315 3.40341 3.65358 3.52843 3.52856C3.65346 3.40353 3.82303 3.33329 3.99984 3.33329H4.99984C5.35346 3.33329 5.6926 3.47377 5.94265 3.72382C6.19269 3.97387 6.33317 4.313 6.33317 4.66663C6.33317 5.02025 6.19269 5.35939 5.94265 5.60943C5.6926 5.85948 5.35346 5.99996 4.99984 5.99996H3.99984M8.6665 8.66663H8.67317M0.666504 9.99996V3.66663C0.666504 2.87098 0.982574 2.10791 1.54518 1.54531C2.10779 0.982696 2.87085 0.666626 3.6665 0.666626H8.33317C8.72714 0.666626 9.11724 0.744223 9.48122 0.894987C9.8452 1.04575 10.1759 1.26673 10.4545 1.54531C10.7331 1.82388 10.954 2.1546 11.1048 2.51858C11.2556 2.88255 11.3332 3.27266 11.3332 3.66663V8.33329C11.3332 8.72726 11.2556 9.11737 11.1048 9.48134C10.954 9.84532 10.7331 10.176 10.4545 10.4546C10.1759 10.7332 9.8452 10.9542 9.48122 11.1049C9.11724 11.2557 8.72714 11.3333 8.33317 11.3333H1.99984C1.64622 11.3333 1.30708 11.1928 1.05703 10.9428C0.80698 10.6927 0.666504 10.3536 0.666504 9.99996Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PlantIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 7H9C10.0609 7 11.0783 6.57857 11.8284 5.82843C12.5786 5.07828 13 4.06087 13 3V2.33333H11C9.93913 2.33333 8.92172 2.75476 8.17157 3.50491C7.42143 4.25505 7 5.27247 7 6.33333H5C3.93913 6.33333 2.92172 5.91191 2.17157 5.16176C1.42143 4.41161 1 3.3942 1 2.33333V1H3C4.06087 1 5.07828 1.42143 5.82843 2.17157C6.57857 2.92172 7 3.93913 7 5V9M3.66667 9H10.3333V11.6667C10.3333 12.0203 10.1929 12.3594 9.94281 12.6095C9.69276 12.8595 9.35362 13 9 13H5C4.64638 13 4.30724 12.8595 4.05719 12.6095C3.80714 12.3594 3.66667 12.0203 3.66667 11.6667V9Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PoolIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.3335 12.3333C1.48494 12.5443 1.68548 12.7153 1.91778 12.8314C2.15008 12.9476 2.40717 13.0054 2.66683 13C2.92649 13.0054 3.18358 12.9476 3.41588 12.8314C3.64818 12.7153 3.84872 12.5443 4.00016 12.3333C4.15161 12.1223 4.35214 11.9514 4.58445 11.8352C4.81675 11.7191 5.07383 11.6612 5.3335 11.6667C5.59316 11.6612 5.85025 11.7191 6.08255 11.8352C6.31485 11.9514 6.51538 12.1223 6.66683 12.3333C6.81828 12.5443 7.01881 12.7153 7.25111 12.8314C7.48341 12.9476 7.7405 13.0054 8.00016 13C8.25983 13.0054 8.51691 12.9476 8.74921 12.8314C8.98151 12.7153 9.18205 12.5443 9.3335 12.3333C9.48494 12.1223 9.68548 11.9514 9.91778 11.8352C10.1501 11.7191 10.4072 11.6612 10.6668 11.6667C10.9265 11.6612 11.1836 11.7191 11.4159 11.8352C11.6482 11.9514 11.8487 12.1223 12.0002 12.3333C12.1516 12.5443 12.3521 12.7153 12.5844 12.8314C12.8167 12.9476 13.0738 13.0054 13.3335 13C13.5932 13.0054 13.8502 12.9476 14.0825 12.8314C14.3148 12.7153 14.5154 12.5443 14.6668 12.3333M1.3335 9.66667C1.48494 9.87766 1.68548 10.0486 1.91778 10.1648C2.15008 10.2809 2.40717 10.3388 2.66683 10.3333C2.92649 10.3388 3.18358 10.2809 3.41588 10.1648C3.64818 10.0486 3.84872 9.87766 4.00016 9.66667C4.15161 9.45567 4.35214 9.28472 4.58445 9.16857C4.81675 9.05242 5.07383 8.99456 5.3335 9C5.59316 8.99456 5.85025 9.05242 6.08255 9.16857C6.31485 9.28472 6.51538 9.45567 6.66683 9.66667C6.81828 9.87766 7.01881 10.0486 7.25111 10.1648C7.48341 10.2809 7.7405 10.3388 8.00016 10.3333C8.25983 10.3388 8.51691 10.2809 8.74921 10.1648C8.98151 10.0486 9.18205 9.87766 9.3335 9.66667C9.48494 9.45567 9.68548 9.28472 9.91778 9.16857C10.1501 9.05242 10.4072 8.99456 10.6668 9C10.9265 8.99456 11.1836 9.05242 11.4159 9.16857C11.6482 9.28472 11.8487 9.45567 12.0002 9.66667C12.1516 9.87766 12.3521 10.0486 12.5844 10.1648C12.8167 10.2809 13.0738 10.3388 13.3335 10.3333C13.5932 10.3388 13.8502 10.2809 14.0825 10.1648C14.3148 10.0486 14.5154 9.87766 14.6668 9.66667M10.0002 7V2C10.0002 1.73478 10.1055 1.48043 10.2931 1.29289C10.4806 1.10536 10.7349 1 11.0002 1C11.2654 1 11.5197 1.10536 11.7073 1.29289C11.8948 1.48043 12.0002 1.73478 12.0002 2M6.00016 7V2C6.00016 1.73478 5.89481 1.48043 5.70727 1.29289C5.51973 1.10536 5.26538 1 5.00016 1C4.73495 1 4.48059 1.10536 4.29306 1.29289C4.10552 1.48043 4.00016 1.73478 4.00016 2M10.0002 2.33333H6.00016M6.00016 5.66667H10.0002"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const GrillIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.7,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00016 9.99996C8.00016 10.3536 8.14064 10.6927 8.39069 10.9428C8.64074 11.1928 8.97987 11.3333 9.3335 11.3333C9.68712 11.3333 10.0263 11.1928 10.2763 10.9428C10.5264 10.6927 10.6668 10.3536 10.6668 9.99996C10.6668 9.64634 10.5264 9.3072 10.2763 9.05715C10.0263 8.8071 9.68712 8.66663 9.3335 8.66663C8.97987 8.66663 8.64074 8.8071 8.39069 9.05715C8.14064 9.3072 8.00016 9.64634 8.00016 9.99996ZM8.00016 9.99996H2.66683M8.00016 7.33329L8.66683 8.66663M4.00016 7.33329L2.00016 11.3333M8.00016 1.33329V0.666626M6.00016 1.33329V0.666626M4.00016 1.33329V0.666626M10.6668 3.33329H1.3335C1.3335 4.39416 1.75492 5.41157 2.50507 6.16172C3.25521 6.91187 4.27263 7.33329 5.3335 7.33329H6.66683C7.70221 7.33402 8.69754 6.93325 9.44352 6.21524C10.1895 5.49724 10.628 4.51795 10.6668 3.48329V3.33329Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const WashMachineIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.3335 8.33333C3.3335 9.04058 3.61445 9.71885 4.11454 10.219C4.61464 10.719 5.29292 11 6.00016 11C6.70741 11 7.38568 10.719 7.88578 10.219C8.38588 9.71885 8.66683 9.04058 8.66683 8.33333M3.3335 8.33333C3.3335 7.62609 3.61445 6.94781 4.11454 6.44772C4.61464 5.94762 5.29292 5.66667 6.00016 5.66667C6.70741 5.66667 7.38568 5.94762 7.88578 6.44772C8.38588 6.94781 8.66683 7.62609 8.66683 8.33333M3.3335 8.33333C4.22216 7.88867 5.1115 7.88867 6.00016 8.33333C6.88883 8.778 7.77816 8.778 8.66683 8.33333M3.3335 3H3.34016M5.3335 3H5.34016M7.3335 3H8.66683M1.3335 2.33333C1.3335 1.97971 1.47397 1.64057 1.72402 1.39052C1.97407 1.14048 2.31321 1 2.66683 1H9.3335C9.68712 1 10.0263 1.14048 10.2763 1.39052C10.5264 1.64057 10.6668 1.97971 10.6668 2.33333V11.6667C10.6668 12.0203 10.5264 12.3594 10.2763 12.6095C10.0263 12.8595 9.68712 13 9.3335 13H2.66683C2.31321 13 1.97407 12.8595 1.72402 12.6095C1.47397 12.3594 1.3335 12.0203 1.3335 11.6667V2.33333Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const Ironing3Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 7H7.00667M5 1H9.97267C10.4461 1.00003 10.9042 1.16801 11.2654 1.47405C11.6266 1.78009 11.8675 2.20434 11.9453 2.67133L12.87 8.224C12.8859 8.31941 12.8808 8.41712 12.8551 8.51037C12.8294 8.60361 12.7837 8.69015 12.7213 8.76398C12.6588 8.83781 12.581 8.89716 12.4933 8.93792C12.4056 8.97868 12.3101 8.99986 12.2133 9H1C1 7.76232 1.49167 6.57534 2.36683 5.70017C3.242 4.825 4.42899 4.33333 5.66667 4.33333H12.2M5 7H5.00667M9 7H9.00667"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const GardenCartIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6668 7.99996C12.1089 7.99996 12.5328 8.17555 12.8453 8.48811C13.1579 8.80068 13.3335 9.2246 13.3335 9.66663C13.3335 10.1087 13.1579 10.5326 12.8453 10.8451C12.5328 11.1577 12.1089 11.3333 11.6668 11.3333C11.2248 11.3333 10.8009 11.1577 10.4883 10.8451C10.1758 10.5326 10.0002 10.1087 10.0002 9.66663C10.0002 9.2246 10.1758 8.80068 10.4883 8.48811C10.8009 8.17555 11.2248 7.99996 11.6668 7.99996ZM11.6668 7.99996L14.0002 3.33329H4.00016V10.6666C4.00029 10.8071 4.04477 10.9439 4.12725 11.0576C4.20974 11.1712 4.32601 11.2559 4.45949 11.2996C4.59296 11.3433 4.73683 11.3437 4.87055 11.3008C5.00428 11.2579 5.12103 11.1738 5.20416 11.0606L7.66683 7.66663V7.70329M11.6668 7.99996L6.9335 7.50196C6.45064 7.45121 5.9908 7.2696 5.60357 6.97671C5.21634 6.68382 4.91642 6.29078 4.73616 5.83996L2.83416 1.08663C2.78484 0.962794 2.69954 0.856588 2.58926 0.781721C2.47898 0.706854 2.34879 0.666764 2.2155 0.666626H1.3335"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const TractorIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.66667 8.00004V8.00671M10.3333 9.33337C10.3333 9.687 10.4738 10.0261 10.7239 10.2762C10.9739 10.5262 11.313 10.6667 11.6667 10.6667C12.0203 10.6667 12.3594 10.5262 12.6095 10.2762C12.8595 10.0261 13 9.687 13 9.33337C13 8.97975 12.8595 8.64061 12.6095 8.39056C12.3594 8.14052 12.0203 8.00004 11.6667 8.00004C11.313 8.00004 10.9739 8.14052 10.7239 8.39056C10.4738 8.64061 10.3333 8.97975 10.3333 9.33337ZM10.3333 9.33337H6M12.3333 8.13337V5.33337C12.3333 5.15656 12.2631 4.98699 12.1381 4.86197C12.013 4.73695 11.8435 4.66671 11.6667 4.66671H7.66667L6.33333 1.33337H2.33333V5.66671M11 1.33337H10.3333C10.1565 1.33337 9.98695 1.40361 9.86193 1.52864C9.7369 1.65366 9.66667 1.82323 9.66667 2.00004V4.66671M1 8.00004C1 8.70728 1.28095 9.38556 1.78105 9.88566C2.28115 10.3858 2.95942 10.6667 3.66667 10.6667C4.37391 10.6667 5.05219 10.3858 5.55229 9.88566C6.05238 9.38556 6.33333 8.70728 6.33333 8.00004C6.33333 7.2928 6.05238 6.61452 5.55229 6.11442C5.05219 5.61433 4.37391 5.33337 3.66667 5.33337C2.95942 5.33337 2.28115 5.61433 1.78105 6.11442C1.28095 6.61452 1 7.2928 1 8.00004Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PaintIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 0.8,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6668 3H11.3335C11.6871 3 12.0263 3.14048 12.2763 3.39052C12.5264 3.64057 12.6668 3.97971 12.6668 4.33333C12.6668 5.21739 12.3156 6.06523 11.6905 6.69036C11.0654 7.31548 10.2176 7.66667 9.3335 7.66667H6.00016V9M1.3335 2.33333C1.3335 1.97971 1.47397 1.64057 1.72402 1.39052C1.97407 1.14048 2.31321 1 2.66683 1H9.3335C9.68712 1 10.0263 1.14048 10.2763 1.39052C10.5264 1.64057 10.6668 1.97971 10.6668 2.33333V3.66667C10.6668 4.02029 10.5264 4.35943 10.2763 4.60948C10.0263 4.85952 9.68712 5 9.3335 5H2.66683C2.31321 5 1.97407 4.85952 1.72402 4.60948C1.47397 4.35943 1.3335 4.02029 1.3335 3.66667V2.33333ZM4.66683 9.66667C4.66683 9.48986 4.73707 9.32029 4.86209 9.19526C4.98712 9.07024 5.15668 9 5.3335 9H6.66683C6.84364 9 7.01321 9.07024 7.13823 9.19526C7.26326 9.32029 7.3335 9.48986 7.3335 9.66667V12.3333C7.3335 12.5101 7.26326 12.6797 7.13823 12.8047C7.01321 12.9298 6.84364 13 6.66683 13H5.3335C5.15668 13 4.98712 12.9298 4.86209 12.8047C4.73707 12.6797 4.66683 12.5101 4.66683 12.3333V9.66667Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const NoteTextIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 21.5V19.2C16 18.0799 16 17.5198 16.218 17.092C16.4097 16.7157 16.7157 16.4097 17.092 16.218C17.5198 16 18.0799 16 19.2 16H21.5M7 7H15M7 11H13M7 15H9M15.1716 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V15.1716C22 15.5088 22 15.6774 21.9912 15.8399C21.9171 17.2049 21.3791 18.5036 20.4663 19.5212C20.3577 19.6423 20.2385 19.7615 20 20V20C19.7615 20.2385 19.6423 20.3577 19.5212 20.4663C18.5036 21.3791 17.2049 21.9171 15.8399 21.9912C15.6774 22 15.5088 22 15.1716 22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const Redo2Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 15V7M22 15H14.2222M22 15C22 15 17 7 11 7C3 7 2 15 2 15"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const ArrowTopRightRecIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 16L16 8M16 8V14M16 8H10M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const InboxIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 14H5.28726C5.9134 14 6.22647 14 6.51065 14.0863C6.76223 14.1627 6.99628 14.288 7.1994 14.4549C7.42884 14.6435 7.6025 14.904 7.94982 15.425L8.04987 15.575C8.3972 16.096 8.57086 16.3565 8.8003 16.5451C9.00342 16.712 9.23747 16.8373 9.48904 16.9137C9.77322 17 10.0863 17 10.7124 17H13.2873C13.9134 17 14.2265 17 14.5106 16.9137C14.7622 16.8373 14.9963 16.712 15.1994 16.5451C15.4288 16.3565 15.6025 16.096 15.9498 15.575L16.0499 15.425C16.3972 14.904 16.5709 14.6435 16.8003 14.4549C17.0034 14.288 17.2375 14.1627 17.489 14.0863C17.7732 14 18.0863 14 18.7124 14H21.5M3.48505 8.05962L2.86901 10.5237C2.72848 11.0858 2.65821 11.3668 2.60216 11.6471C2.29157 13.2003 2.29156 14.7997 2.60214 16.3529C2.65818 16.6332 2.72844 16.9143 2.86897 17.4764V17.4764C3.04386 18.1759 3.1313 18.5257 3.24914 18.8261C3.91515 20.5237 5.45262 21.7241 7.26113 21.9585C7.58111 22 7.94165 22 8.66275 22H15.3369C16.0581 22 16.4187 22 16.7387 21.9585C18.5472 21.7241 20.0846 20.5237 20.7506 18.8261C20.8684 18.5257 20.9559 18.1759 21.1308 17.4763V17.4763C21.2714 16.9141 21.3416 16.633 21.3977 16.3527C21.7082 14.7996 21.7082 13.2004 21.3977 11.6473C21.3417 11.367 21.2714 11.0859 21.1309 10.5237L20.5149 8.05981C19.9733 5.89312 19.7024 4.80977 19.0985 4.00314C18.5656 3.29144 17.8525 2.73471 17.0328 2.39032C16.1038 2 14.9871 2 12.7537 2H11.2462C9.01285 2 7.89619 2 6.96718 2.39031C6.1475 2.73469 5.43446 3.2914 4.90156 4.00308C4.29757 4.80968 4.02673 5.89299 3.48505 8.05962Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const InfinityIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 16.0004C9.16434 16.6281 8.12561 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C9.76142 7 12 9.23858 12 12C12 14.7614 14.2386 17 17 17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7C15.8742 7 14.8353 7.37209 13.9995 8"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const BroomIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.24,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8333 9.16602L18.3333 1.66602"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1666 10.4988C12.8333 11.1655 12.9166 12.2488 12.3333 12.9988L8.33329 18.3322L1.66663 11.6655L6.99996 7.66548C7.74996 7.08215 8.83329 7.16548 9.49996 7.83215L12.1666 10.4988Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66663 8.66699L11.3333 14.3337"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16663 14.1657L5.33329 12.999"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="177" width="21" height="21" rx="10.5" fill="#F5F5F5" />
    <path
      d="M188.893 6.27273V15H187.837V7.38068H187.786L185.655 8.79545V7.72159L187.837 6.27273H188.893Z"
      fill="#737373"
    />
  </Box>
);

export const CashIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 2.5V2.5C7 3.89782 7 4.59674 6.77164 5.14805C6.46716 5.88313 5.88313 6.46716 5.14805 6.77164C4.59674 7 3.89782 7 2.5 7V7M17 2.5V2.5C17 3.89782 17 4.59674 17.2284 5.14805C17.5328 5.88313 18.1169 6.46716 18.8519 6.77164C19.4033 7 20.1022 7 21.5 7V7M17 17.5V17.5C17 16.1022 17 15.4033 17.2284 14.8519C17.5328 14.1169 18.1169 13.5328 18.8519 13.2284C19.4033 13 20.1022 13 21.5 13V13M7 17.5V17.5C7 16.1022 7 15.4033 6.77164 14.8519C6.46716 14.1169 5.88313 13.5328 5.14805 13.2284C4.59674 13 3.89782 13 2.5 13V13M5 22H19M14 10.0005C14 11.1051 13.1046 12.0005 12 12.0005C10.8954 12.0005 10 11.1051 10 10.0005C10 8.89592 10.8954 8.00049 12 8.00049C13.1046 8.00049 14 8.89592 14 10.0005ZM22 11.6V8.4C22 6.15979 22 5.03968 21.564 4.18404C21.1805 3.43139 20.5686 2.81947 19.816 2.43597C18.9603 2 17.8402 2 15.6 2L8.4 2C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V11.6C2 13.8402 2 14.9603 2.43597 15.816C2.81947 16.5686 3.43139 17.1805 4.18404 17.564C5.03968 18 6.15979 18 8.4 18H15.6C17.8402 18 18.9603 18 19.816 17.564C20.5686 17.1805 21.1805 16.5686 21.564 15.816C22 14.9603 22 13.8402 22 11.6Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const AlignLeft3Icon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 3L2 21M10.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V11.8C22 10.1198 22 9.27976 21.673 8.63803C21.3854 8.07354 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H10.8C9.11984 7 8.27976 7 7.63803 7.32698C7.07354 7.6146 6.6146 8.07354 6.32698 8.63803C6 9.27976 6 10.1198 6 11.8V12.2C6 13.8802 6 14.7202 6.32698 15.362C6.6146 15.9265 7.07354 16.3854 7.63803 16.673C8.27976 17 9.11984 17 10.8 17Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const DistributeHorizontallyIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 3L2 21M22 3V21M11.8 20H12.2C13.8802 20 14.7202 20 15.362 19.673C15.9265 19.3854 16.3854 18.9265 16.673 18.362C17 17.7202 17 16.8802 17 15.2V8.8C17 7.11984 17 6.27976 16.673 5.63803C16.3854 5.07354 15.9265 4.6146 15.362 4.32698C14.7202 4 13.8802 4 12.2 4H11.8C10.1198 4 9.27976 4 8.63803 4.32698C8.07354 4.6146 7.6146 5.07354 7.32698 5.63803C7 6.27976 7 7.11984 7 8.8V15.2C7 16.8802 7 17.7202 7.32698 18.362C7.6146 18.9265 8.07354 19.3854 8.63803 19.673C9.27976 20 10.1198 20 11.8 20Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

const CollapseIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.6665 13.3333L7.99984 10L11.3332 13.3333"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 2.66663L7.99984 5.99996L11.3332 2.66663"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const CalendarArrowRightIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 1V4M16 1V4M16 12H8M16 12L13 9M16 12L13 15M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PaperclipIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 12L15.25 18.75C12.3505 21.6495 7.64949 21.6495 4.75 18.75C1.85051 15.8505 1.8505 11.1495 4.75 8.25L9.5 3.5C11.433 1.56701 14.567 1.567 16.5 3.5C18.433 5.433 18.433 8.567 16.5 10.5L11.75 15.25C10.7835 16.2165 9.2165 16.2165 8.25 15.25C7.2835 14.2835 7.2835 12.7165 8.25 11.75L13 7"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ForwardRecIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 11L15 8M18 11L15 14M18 11H10.6667C8.08937 11 6 13.0894 6 15.6667V16.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PlusRecIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 12H12M12 12H16M12 12V8M12 12V16M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const PercentageRecIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99996 4.66797L5.99996 11.3346M6.66663 6.33464C6.66663 6.88692 6.21891 7.33464 5.66663 7.33464C5.11434 7.33464 4.66663 6.88692 4.66663 6.33464C4.66663 5.78235 5.11434 5.33464 5.66663 5.33464C6.21891 5.33464 6.66663 5.78235 6.66663 6.33464ZM11.3333 9.66797C11.3333 10.2203 10.8856 10.668 10.3333 10.668C9.78101 10.668 9.33329 10.2203 9.33329 9.66797C9.33329 9.11568 9.78101 8.66797 10.3333 8.66797C10.8856 8.66797 11.3333 9.11568 11.3333 9.66797ZM7.73337 14.6673H8.26671C10.5069 14.6673 11.627 14.6673 12.4827 14.2313C13.2353 13.8479 13.8472 13.2359 14.2307 12.4833C14.6667 11.6276 14.6667 10.5075 14.6667 8.26732V7.73399C14.6667 5.49377 14.6667 4.37367 14.2307 3.51802C13.8472 2.76537 13.2353 2.15345 12.4827 1.76996C11.627 1.33398 10.5069 1.33398 8.26671 1.33398H7.73337C5.49316 1.33398 4.37306 1.33398 3.51741 1.76996C2.76476 2.15345 2.15284 2.76537 1.76935 3.51802C1.33337 4.37367 1.33337 5.49377 1.33337 7.73398V8.26732C1.33337 10.5075 1.33337 11.6276 1.76935 12.4833C2.15284 13.2359 2.76476 13.8479 3.51741 14.2313C4.37306 14.6673 5.49316 14.6673 7.73337 14.6673Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FunctionsRecIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6666 4.66634H5.33325L8.7676 7.99967L5.33325 11.333H10.6666M6.66658 14.6663H9.33325C11.2001 14.6663 12.1335 14.6663 12.8466 14.303C13.4738 13.9835 13.9837 13.4735 14.3033 12.8463C14.6666 12.1333 14.6666 11.1999 14.6666 9.33301V6.66634C14.6666 4.7995 14.6666 3.86608 14.3033 3.15304C13.9837 2.52583 13.4738 2.0159 12.8466 1.69632C12.1335 1.33301 11.2001 1.33301 9.33325 1.33301H6.66659C4.79974 1.33301 3.86632 1.33301 3.15328 1.69632C2.52608 2.0159 2.01614 2.52583 1.69656 3.15304C1.33325 3.86608 1.33325 4.7995 1.33325 6.66634V9.33301C1.33325 11.1998 1.33325 12.1333 1.69656 12.8463C2.01614 13.4735 2.52608 13.9835 3.15328 14.303C3.86632 14.6663 4.79974 14.6663 6.66658 14.6663Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FolderPlusIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 14H12M12 14H15M12 14V11M12 14V17M6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FolderCrossIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 16.5L12 14M12 14L14.5 11.5M12 14L9.5 11.5M12 14L14.5 16.5M6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const FolderMoveIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 14H15M12.5 11.5L15 14L12.5 16.5M6.8 2H8.31672C9.11834 2 9.51916 2 9.88103 2.09146C10.4791 2.24262 11.016 2.57444 11.4186 3.04174C11.6623 3.32451 11.8415 3.683 12.2 4.4C12.439 4.878 12.5585 5.11699 12.7209 5.30551C12.9894 5.61704 13.3473 5.83825 13.746 5.93902C13.9872 6 14.2544 6 14.7889 6H15.6C17.8402 6 18.9603 6 19.816 6.43597C20.5686 6.81947 21.1805 7.43139 21.564 8.18404C22 9.03968 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const ShieldCheckIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 12L11 14L15.5 9.5M9.40073 2.15522L5.85055 3.73307C4.81876 4.19164 4.30286 4.42093 3.92457 4.78336C3.59019 5.10373 3.33451 5.49715 3.17756 5.93283C3 6.42571 3 6.99026 3 8.11937V13.5748C3 14.8271 3 15.4532 3.17261 16.0216C3.32541 16.5247 3.57593 16.9928 3.90982 17.3991C4.28698 17.858 4.80796 18.2053 5.84992 18.8999L9.33744 21.2249C10.2997 21.8664 10.7809 22.1872 11.3009 22.3118C11.7605 22.422 12.2395 22.422 12.6991 22.3118C13.2192 22.1872 13.7003 21.8664 14.6626 21.2249L18.1501 18.8999C19.192 18.2053 19.713 17.858 20.0902 17.3991C20.4241 16.9928 20.6746 16.5247 20.8274 16.0216C21 15.4532 21 14.8271 21 13.5748V8.11937C21 6.99026 21 6.42571 20.8224 5.93283C20.6655 5.49715 20.4098 5.10373 20.0754 4.78336C19.6971 4.42093 19.1813 4.19164 18.1495 3.73307L14.5993 2.15522C13.6421 1.72982 13.1635 1.51711 12.666 1.43311C12.2251 1.35865 11.7749 1.35865 11.334 1.43311C10.8365 1.51711 10.3579 1.72982 9.40073 2.15522Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export const TagIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 7.5H7.51M3 6V11.17A2 2 0 0 0 3.59 12.59L11.3 20.3A2.41 2.41 0 0 0 14.71 20.3L20.29 14.72A2.41 2.41 0 0 0 20.29 11.31L12.59 3.59A2 2 0 0 0 11.17 3H6A3 3 0 0 0 3 6Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const LockIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 11H17A2 2 0 0 1 19 13V19A2 2 0 0 1 17 21H7A2 2 0 0 1 5 19V13A2 2 0 0 1 7 11ZM8 11V7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7V11"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const PencilIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 20H8L19 9L15 5L4 16V20ZM13.5 6.5L17.5 10.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const LayoutIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 3H19A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3ZM3 9H21M9 21V9"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

export const PaperCheckIcon = ({
  size = defaultSize,
  color = defaultColor,
  strokeWidth = 1.5,
  ...props
}: IconProps) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6H20A2 2 0 0 1 22 8V16A2 2 0 0 1 20 18H4A2 2 0 0 1 2 16V8A2 2 0 0 1 4 6ZM5 10H11M16 10H19M14 14.5H19M5 14.5C6 13.3 6.8 13.3 7.4 14.5C8 15.7 8.8 15.7 9.8 14.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Box>
);

// export default all consts from this file
export default {
  TagIcon,
  LockIcon,
  PencilIcon,
  LayoutIcon,
  ShieldCheckIcon,
  FolderCrossIcon,
  FolderMoveIcon,
  FolderPlusIcon,
  FunctionsRecIcon,
  PercentageRecIcon,
  PlusRecIcon,
  ForwardRecIcon,
  PaperclipIcon,
  WrenchIcon,
  ArrowUpDownIcon,
  ArrowSwapIcon,
  AlertTriangleFilledIcon,
  CloudDownloadIcon,
  CalendarArrowRightIcon,
  CollapseIcon,
  DistributeHorizontallyIcon,
  AlignLeft3Icon,
  UserSquareIcon,
  CashIcon,
  PaperCheckIcon,
  BroomIcon,
  InfinityIcon,
  CalendarCrossIcon,
  InboxIcon,
  ArrowTopRightRecIcon,
  FileCheckIcon,
  ArrowBottomIcon,
  ArrowTopIcon,
  Redo2Icon,
  LogOutIcon,
  NoteTextIcon,
  GardenCartIcon,
  PaintIcon,
  Ironing3Icon,
  TractorIcon,
  BookingComIcon,
  StripeIcon,
  WashMachineIcon,
  GrillIcon,
  PoolIcon,
  ClockZzzIcon,
  PauseIcon,
  FormulaIcon,
  FastForwardIcon,
  WalletMinusIcon,
  WalletPlusIcon,
  FilterIcon,
  ClockIcon,
  TimeIcon,
  GlobeIcon,
  Globe2Icon,
  CloudUploadIcon,
  Tag2Icon,
  ToggleOnIcon,
  Lock2Icon,
  ArrowRightCircleIcon,
  Activity2Icon,
  Grid06Icon,
  BriefcaseIcon,
  DashboardIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
  CalculatorIcon,
  FingerprintIcon,
  NotificationIcon,
  GeneralIcon,
  FileTextIcon,
  ExternalLinkIcon,
  Link2Icon,
  Calculator2Icon,
  FileText2Icon,
  MembersIcon,
  BillingIcon,
  PlansIcon,
  ApiTokensIcon,
  WebhookIcon,
  OwnerPortalIcon,
  OwnerStatementsIcon,
  BankAccountIcon,
  CircleDollarIcon,
  HomeIcon,
  BedIcon,
  PlusIcon,
  PlusCircleIcon,
  MinusCircleIcon,
  UserCrossIcon,
  PercentageCircleIcon,
  PercentageIcon,
  AutomationsIcon,
  ChevronIcon,
  SearchIcon,
  ArchiveIcon,
  CheckIcon,
  CrossIcon,
  CrossCircleIcon,
  FileDownloadIcon,
  RefreshCwIcon,
  CopyIcon,
  TrashIcon,
  EyeIcon,
  EyeSlashIcon,
  AiSparkIcon,
  AiSparkOffIcon,
  RocketIcon,
  ContactAtIcon,
  EmailIcon,
  CommentQuestionIcon,
  GearIcon,
  Menu2RecIcon,
  MenuIcon,
  Maximize3Icon,
  MinimizeIcon,
  ArrowRightIcon,
  ArrowCornerCcwRbIcon,
  ImportIcon,
  ExportIcon,
  SlidersHorizIcon,
  ListUnorderedIcon,
  ShareIcon,
  MoreHorizontalIcon,
  GripVerticalIcon,
  PinIcon,
  PhoneIcon,
  Edit3Icon,
  FunctionsIcon,
  ZeroIcon,
  AlignMiddleIcon,
  HistoryIcon,
  ClipboardTextIcon,
  ClipboardSlashIcon,
  ShuffleIcon,
  CalendarEventIcon,
  RouteIcon,
  Loader2Icon,
  LoaderIcon,
  BookOpenIcon,
  FolderOpenIcon,
  LightningIcon,
  FileInvoiceIcon,
  OfficeIcon,
  AlertTriangleIcon,
  HashtagIcon,
  ArrowLeftIcon,
  CalendarDatesIcon,
  AlertCircleIcon,
  LogIn2Icon,
  LogOut2Icon,
  CheckCircleIcon,
  CreditCardOutcomeIcon,
  CreditCardIncomeIcon,
  InfoIcon,
  Send2Icon,
};
